/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Breadcrumb } from 'app/core/services/breadcrumb/breadcrumb.interface';
import { BreadcrumbService } from 'app/core/services/breadcrumb/breadcrumb.service';
import { SharedService } from '../../core/services/shared.service';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { DispatchBoardService } from '../../../../../dispatch-board/src/app/components/dispatch-board/dispatch-board.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { CalendarService } from '../services/calendar.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { CalendarSettingsComponent } from '../calendar-settings/calendar-settings.component';
import { TemplateService } from '../../core/services/template.service';
import moment, { Moment } from 'moment';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { NoteDialogComponent } from 'app/components/notes/note-dialog/note-dialog.component';
import { NoteDialogService } from 'app/components/notes/note-dialog/note-dialog.service';
import { dataObj } from 'app/modules/jobs/job-form/job-form.type';
import { JobFormComponent } from 'app/modules/jobs/job-form/job-form.component';
import { UpdateScheduledDateComponent } from 'app/modules/jobs/job-details/edit-job-schedule/edit-job-schedule.component';
import { PreviewDataOptions } from 'app/components/preview-data/preview-data.interface';
import { DispatchFilterService } from '../../../../../dispatch-board/src/app/components/dispatch-filter/dispatch-filter.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable, ReplaySubject, Subject, Subscription, forkJoin, of } from 'rxjs';
import { ManageCalendarFilterComponent } from '../manage-calendar-filter/manage-calendar-filter.component';
import { Title } from '@angular/platform-browser';
import _, { debounce } from 'lodash';
import { catchError, debounceTime, distinctUntilChanged, filter, map, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { HotToastService } from '@ngneat/hot-toast';
import { NgxTippyProps, NgxTippyService } from 'ngx-tippy-wrapper';
import { BadgeOptions } from 'app/components/badge/badge.interface';
import { BryntumCalendarComponent } from '@bryntum/calendar-angular-thin';
import { Calendar, CalendarConfig, MonthView } from '@bryntum/calendar-thin';
import { DateHelper, DatePicker, DatePickerConfig, DomConfig, DragHelper, DragHelperConfig } from '@bryntum/core-thin';
import { EventStore } from '@bryntum/schedulerpro-thin';
import { Grid, GridConfig } from '@bryntum/grid-thin';
import { MatDialog } from '@angular/material/dialog';
import { calendarModule } from 'app/components/datagrid/datagrid.interface';
import { BryntumGridComponent } from '@bryntum/grid-angular-thin';
import { NewTimeOffComponent } from 'app/components/new-timeoff/new-timeoff.component';
import { TimeoffDetailsComponent } from 'app/components/timeoff-details/timeoff-details.component';
import { UpdateDueDateComponent } from 'app/modules/jobs/job-details/edit-due-date/edit-due-date.component';
import { AnalyticsService } from 'app/core/services/analytics/analytics.service';
import { ActionSelectorOption } from 'app/components/action-selector/action-selector.interface';
import { ActionSelectorComponent } from 'app/components/action-selector/action-selector.component';
import dayjs from 'dayjs';
import { ActivatedRoute } from '@angular/router';
import { Permissions } from '../../../../../dispatch-board/src/app/components/dispatch-board/dispatch-board.interface';
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CalendarComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('calendar') calendarComponent!: BryntumCalendarComponent;
  @ViewChild('datePicker') datePicker!: DatePicker;
  @ViewChild('calendarHolidayDialog', { static: true }) calendarHolidayDialog: TemplateRef<any>;
  @ViewChild('gridView', { static: false }) gridViewInstance!: BryntumGridComponent;
  settingsDialogdata: any = {};
  weekNumber: number = 0;
  panelOpenState: boolean = true;
  showCalendar: boolean = false;
  calendar!: Calendar;
  eventStore!: EventStore;
  metaData: any;
  createdJobId: any;
  selectedQuickFilter: string = 'ALL';
  fallbackSelectedQuickFilter: string = 'ALL';
  gridFeatures = {};
  holidays = [];
  gridPageNumber: string = '1';
  gridFilterOptions: any;
  gridViewType: 'listView' | 'tableView';
  cardViewInstance: Grid;
  selectedDate: string = '';
  selectedMonth: string = '';
  tableViewInstance: any;
  cardConfig: Partial<GridConfig>;
  tableConfig: Partial<GridConfig>;
  cardData = [];
  loaded: boolean = false;
  jobsArr = [];
  jobsArrBackup = [];
  eventCountArr: [] = [];
  eventCountMap: any;
  startDate: any = new Date();
  activeDate: any = new Date();
  sliderHeightValue: number = 0;
  sliderWidthValue: number = 0;
  showCalendarPicker: boolean = false;
  showSidePanel: boolean = true;
  filterExpand: boolean = false;
  calendarMode: string = 'week';
  previewDataOptions: PreviewDataOptions;
  calendarConfig: any;
  pickerConfig: Partial<DatePickerConfig>;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  defaultGridPreference = { page: 1, count: 10, type: 'UNASSIGNED', sort_by: 'scheduled_start_time', sort: 'DESC' };
  defaultFilterOptions = {
    // eslint-disable-next-line @typescript-eslint/naming-convention, max-len
    'job': { 'filterOptions': { 'filter.keyword': '', 'filter.job_category': '', 'filter.job_status': '', 'filter.due_date_from': '', 'filter.due_date_to': '', 'filter.from_date': '', 'filter.to_date': '', 'filter.skillset_uid': '', 'filter.service_territory': '', 'filter.priority': '', 'filter.assigned': '', 'filter.job_tags': '', 'filter.project': '', 'due_date_type': 'ANY', 'schedule_date_type': 'ANY', 'filter.customer': '', 'filter.customer_organization': '', 'filter.property': '' }, 'filterUid': 'ALL', 'filterCount': { 'grid': 0 } },
  };
  miniCalDate: any;
  isMapViewEnabled: boolean;
  events!: Array<Record<string, any>>;
  resources!: Array<Record<string, any>>;
  openNewJobDrawer: boolean = false;
  newJobPrefillData: any = {};
  currentDate: Date = new Date();
  selectedCustDate: Date | null = null;
  maxDivHeight: number;
  miniCalendarHide: boolean = false;
  eventCounts: { date: string; count: number }[] = [];
  autoRowHeight: boolean;
  openDrawer: boolean = false;
  allTimeZones: any[] = [];
  quickFilters: any;
  selectedTimeZone: string;
  selectedTeamTimeZone: string;
  cloneJobData: any = null;
  filterForm: UntypedFormGroup;
  advancedFilterCount: number = 0;
  teamFetching: boolean = false;
  teamParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  teamPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  teams: Observable<any[]> = new Observable<any[]>();
  teamValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  teamOptions: any[] = [];
  // teams: Observable<any[]> = new Observable<any[]>();
  employeeFetching: boolean = false;
  employeeParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  employeePagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  employeeValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  employeeOptions: any[] = [];
  employees: Observable<any[]> = new Observable<any[]>();
  jobUid: any;
  jobsCategory = [];
  // teams = [];
  // employees = [];
  filteredJobCategoryArray = [];
  filteredStatusArray = [];
  selectedStatusItems: string[] = [];
  jobsStatuses: any[] = [];
  isAnyStatus: boolean = false;
  quickFilterLoading: boolean = false;
  jobCalendarValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  filteredEmployeesArray = [];
  filteredTeamsArray = [];
  selectedJobCategoryItems: string[] = [];
  selectedTeamsItems: string[] = [];
  selectedEmployeesItems: string[] = [];
  filterCount = { grid: 0 };
  sortOptions = { grid: { sort_by: 'scheduled_start_time', sort: 'DESC' }, scheduler: {} };
  filterSubscription: Subscription | null = null;
  filteredSubscription: Subscription | null = null;
  eventCountSubscription: Subscription | null = null;
  rescheduleSubscription: Subscription | null = null;
  newTimeoffSubscription: Subscription | null = null;
  calendarSearchKeyword: string = '';
  calendarParams: any = {};
  canReschedule: string = calendarModule.CONTINUE;
  calendarFilterDrawerData = { openFilter: false, jobCalendarFilterValues: {}, saveFilterByDefault: false, hideSaveFilter: false, addNewFilter: false, selectedModule: 'GRID' };
  permissions: Permissions;
  calendarHolidayDialogInstance: any;
  grid = { unscheduledJobcount: 0, allJobs: [], scheduledJobs: [], unscheduledJobs: [] };
  nonJobEventCreateDrawerData = { openDrawer: false, options: null, eventData: null, source: null };
  nonJobEventDetailsDrawerData = { nonJobEventUid: '', openDrawer: false, options: null, drawerName: null };
  nonJobEventParams: any = { page: 1, count: 500 }; //Setting count 500 till backend work done
  cancelNonJobEventRequest: Subject<void> = new Subject<void>();
  calendarNonJobEvents: any[] = [];
  calendarAssignments: any[] = [];
  gridInstance: any;
  gridData: any;
  gridDrawerOptions = { drawerName: 'unscheduled_drawer', show: false, instance: null };
  gridParam = {
    page: 1, limit: 10, sort: 'ASC', sort_by: 'due_date', filter_rules: [
      {
        "displayKeyValue": [
          "UNSCHEDULED"
        ],
        "key": "schedule_status",
        "operator": "EQUAL_TO",
        "field_type": "DROPDOWN",
        "value": "UNSCHEDULED",
        "module": "JOB",
        "type": "default_field"
      },
      {
        "displayKeyValue": [
            "CANCELED"
        ],
        "key": "current_job_status.status_type",
        "operator": "NOT_CONTAINS",
        "field_type": "DROPDOWN",
        "value": [
            "CANCELED"
        ],
        "module": "JOB",
        "type": "default_field"
    }
    ]
  };
  timeOffList = [];
  buttonConfig: any;
  companyConfig: any;
  currentUser: any;
  currentPageNumber = 1;
  gridCardConfig: Partial<GridConfig>;
  totalGridRecords: number = 1;
  totalGridPage: number = 1;
  debouncedTrackEvent = debounce((event) => {
    this._analytics.trackEvent(event);
  }, 300);
  calendarSearchTippyProps: NgxTippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    interactive: true,
    appendTo: document.body,
    placement: 'bottom',
    hideOnClick: 'toggle',
    onClickOutside: () => {
      this.ngxTippyService.hide('tippycalendarSearch');
    },
    onHide: () => {
      // this.ngxTippyService.hide('tippycalendarSearch');
      // this.calendarSearchKeyword = '';
      // this.applyCalendarSearch(null, 'clear');
    }
  };
  forkJoinSubscription: Subscription;
  selectedRedirectedDate = new Date();
  disableModeTab: boolean = false;
  constructor(private http: HttpClient, private breadcrumbService: BreadcrumbService, private _sharedService: SharedService, private _zuperDialogService: ZuperDialogService,
    private _dataCollectorService: DataCollectorService, private _calendarService: CalendarService,
    private _localStorageService: LocalStorageService, public _utilityService: UtilityService, private _toastService: HotToastService,
    private _templateService: TemplateService,
    private _dispatchBoardService: DispatchBoardService,
    private localisationService: LocalisationService,
    private _noteDialogService: NoteDialogService,
    private zuperDialogService: ZuperDialogService,
    private dispatchFilterService: DispatchFilterService,
    private _title: Title,
    private ngxTippyService: NgxTippyService,
    private route: ActivatedRoute,
    private _analytics: AnalyticsService,
    private matDialog: MatDialog) {
    this.rescheduleSubscription = this._utilityService.getUpdates().subscribe((canReschedule) => {
      this.canReschedule = canReschedule;
      if (this.canReschedule === calendarModule.CONFIRMED) {
        this.canReschedule = calendarModule.CONTINUE;
        this.getAllJobs(this.calendar.date);
        this.getEventCount(this.calendar.date);
        this.getGridData();
      } else if (this.canReschedule === calendarModule.CONTINUE) {
        this.updateCalendarData();
        this.setGridList();
      }
    });
    this.newTimeoffSubscription = this._utilityService.getNewTimeoff().subscribe((canReschedule) => {
      if (this.canReschedule === calendarModule.CONFIRMED) {
        this.getAllJobs(this.calendar.date);
        this.getEventCount(this.calendar.date);
      }
    });
  }
  @HostListener('click', ['$event'])
  onMoreViewClick(event: any): any {
    const moreviewElement = event?.target?.parentNode as Element;
    if (moreviewElement?.classList?.contains('calendar-month-overflow-footer')) {
      const moreViewElementParent = moreviewElement.closest('.b-overflowpopup') as Element;
      this.calendar.date = moreViewElementParent?.hasAttribute('data-date') ? new Date(moreViewElementParent.getAttribute('data-date')) : new Date();
      const alldayEle = document.querySelector('[class="b-dayview-allday-row b-show-yscroll-padding b-dayview-allday-row-holiday"]') as HTMLElement;
      alldayEle?.classList?.remove('b-dayview-allday-row-holiday');
      this.changeCalendarMode('day');
    }
  };
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.maxDivHeight = this.miniCalendarHide ? window.innerHeight - 138 : window.innerHeight - 480;
    // Listen for the window resize event and update screen dimensions
    this.calendarConfig.modes = {
      day: {
        height: window.innerHeight - 180,
      },
      week: {
        height: window.innerHeight - 180,
      }
    };
  }

  onAutoRowHeightChanged(event): void {
    (this.calendar.modes as { month: MonthView }).month.autoRowHeight = event.target.checked;
  }


  applyCalendarSearch(event: any, action?: string): void {
    if (event?.keyCode === 13 || action === 'clear') {
      this._analytics.trackEvent('web_calendar_search_icon_clicked');
      const searchKeyword = this.calendarSearchKeyword?.trim();
      this.calendarParams['filter.keyword'] = searchKeyword;
      this.filterSubscription?.unsubscribe();
      this.storeFilterData();
      this.getAllJobs(this.calendar.date);
      this.getEventCount(this.calendar.date);
    }
  }

  ngOnInit(): void {
    this.companyConfig = this._localStorageService.getLocalStorage('company_configuration_data');
    this.selectedTimeZone = this.preferredTimeZone();
    this.currentUser = this._localStorageService.getLocalStorage('user');
    this.buttonConfig = {
      displayKey: 'create.job.text',
      dataKey: 'CREATE',
      isDisabled: !this.checkPermission(this.companyConfig?.jobs?.allow_fe_create, 'job.new'),
      toolTipText: '',
      type: 'BUTTONGROUP',
      children: [
        {
          displayKey: 'text.new_job',
          dataKey: 'CREATE_JOB',
          isEnabled: this.checkPermission(this.companyConfig?.jobs?.allow_fe_create, 'job.new'),
          icon: 'ti ti-briefcase text-2xl'
        },
        {
          displayKey: 'text.new_non_job_event',
          dataKey: 'NEW_NON_JOB_EVENT',
          isEnabled: true,
          icon: 'ti ti-calendar text-2xl'
        },
        {
          displayKey: 'dispatchBoard.scheduler.new_event.dialog.new_timeoff',
          dataKey: 'ADD_TIMEOFF',
          isEnabled: this._utilityService.hasPermission('timesheet.new_timeoff'),
          icon: 'ti ti-clock-x  text-2xl'
        }
      ],
    };
    this._localStorageService.removeLocalStorage('search_page_keyword');
    this.permissions = this._dispatchBoardService.permissions;
    const jobCalendarFilter = this._localStorageService.getLocalStorage('job_calendar_filter');
    this.setGridCardConfig();
    this.getGridData();
    if (jobCalendarFilter) {
      this.advancedFilterCount = Object.keys(jobCalendarFilter)
        .filter(key => jobCalendarFilter[key] && jobCalendarFilter[key] !== 'ANY' && key !== 'filter.job_category' && key !== 'filter.job_status' && key !== 'filter.assigned_to_team' && key !== 'filter.assigned_to' && key !== 'from_date' && key !== 'to_date')
        .length;
      this.selectedJobCategoryItems = jobCalendarFilter ? jobCalendarFilter['filter.job_category'] ? jobCalendarFilter['filter.job_category']?.split(',').map(id => id.trim()) : [] : [];
      this.selectedStatusItems = jobCalendarFilter ? jobCalendarFilter['filter.job_status'] ? jobCalendarFilter['filter.job_status']?.split(',').map(id => id.trim()) : [] : [];
      this.selectedTeamsItems = jobCalendarFilter ? jobCalendarFilter['filter.assigned_to_team'] ? jobCalendarFilter['filter.assigned_to_team']?.split(',').map(id => id.trim()) : [] : [];
      this.selectedEmployeesItems = jobCalendarFilter ? jobCalendarFilter['filter.assigned_to'] ? jobCalendarFilter['filter.assigned_to']?.split(',').map(id => id.trim()) : [] : [];
    }
    this.getHolidays();
    this.getJobCategory();
    this.getAllEmployees(true);
    this.getAllTeams(true);
    this._title.setTitle(this._utilityService.getLocaleValue('calendar.home.tab.title', 'Zuper Pro - Calendar'));
    this.localisationService.setDefaultLanguage();
    this.maxDivHeight = this.miniCalendarHide ? window.innerHeight - 138 : window.innerHeight - 480;
    const _this = this;
    this._sharedService.initateForms();
    this.metaData = this.setDefaultMetaData();
    this.metaData = this._calendarService.sanitizeTemplateMetaData(this.metaData);
    this.updateDateDesc();
    this.setDefaultConfig();
    this.getPreviewDataOptions();
    this.getMetaData();

    this.pickerConfig = {
      date: new Date(),
      width: '24em',
      sixWeeks: true,
      weekStartDay: this.metaData?.calendar?.display?.weekStartDay,
      showWeekNumber: true,
      nonWorkingDays: {
        0: true, // Sunday
        6: true  // Saturday
      },
      cellRenderer: ({ cell, date }): any => {
        const itemDate = moment(date);
        const currentMonth = itemDate.month() + 1;
        const currentYear = itemDate.year();
        const formattedDate = `${currentYear}-${currentMonth}-${itemDate.date()}`;

        // Check if the date exists in the map
        const total = _this.eventCountMap?.get(formattedDate) ?? 0;

        if (total !== undefined) {
          cell.innerHTML += `<span class="picker-event-count">${total}</span>`;
        } else {
          cell.innerHTML += '<span class="picker-event-count">&nbsp;</span>';
        }
      },
      onDateChange: (event): any => {
        const newActiveDate = moment(event?.value);
        const oldActiveDate = moment(event?.oldValue);
        if ((oldActiveDate.month() !== newActiveDate.month()) || (oldActiveDate.year() !== newActiveDate.year())) {
          _this.showCalendarPicker = false;
          this.setEventCount(event.value);
        }
      },
    };
    this.filterForm = new UntypedFormGroup({
      jobCategory: new UntypedFormControl([]),
      teams: new UntypedFormControl([]),
      employees: new UntypedFormControl([]),
      jobStatus: new UntypedFormControl([],)
    });
    this.updateMiniCalendarCss();
  }


  ngAfterViewInit(): void {
    this.calendar = this.calendarComponent?.instance;
    this.gridInstance = this.gridViewInstance?.instance;
    this.calendar.sidebar.hide();
    // this.getAllJobs();
    this._dispatchBoardService.jobPreview.subscribe((jobUid: any) => {
      this.jobUid = jobUid;
      this.openDrawer = true;
    });
    this.getEventCount(new Date());
    const jobCalendarFilter = this._localStorageService.getLocalStorage('job_calendar_filter');
    if (jobCalendarFilter) {
      // eslint-disable-next-line max-len
      this.selectedJobCategoryItems = jobCalendarFilter ? jobCalendarFilter['filter.job_category'] ? jobCalendarFilter['filter.job_category']?.split(',').map(id => id.trim()) : '' : [];
      this.filteredJobCategoryArray = this.jobsCategory.filter(obj => this.selectedJobCategoryItems?.includes(obj.category_uid));
      this.filterForm.get('jobCategory').setValue(this.selectedJobCategoryItems);
      const selectedCategories: any[] = this.filterForm.get('jobCategory')?.value ?? [];
      this.jobsStatuses = selectedCategories.length > 0 ? this.getSelectedCategoriesStatus(selectedCategories) : [];
      this.selectedStatusItems = jobCalendarFilter ? jobCalendarFilter['filter.job_status'] ? jobCalendarFilter['filter.job_status']?.split(',').map(id => id.trim()) : '' : [];
      this.filteredStatusArray = this.jobsStatuses?.filter(obj => this.selectedStatusItems?.includes(obj.status_uid));
      this.filterForm.get('jobStatus').setValue(this.selectedStatusItems);
    }
    this.sliderHeightValue = this.metaData?.calendar?.display['cellControlSize'] || 0;
    this.sliderWidthValue = this.metaData?.calendar?.display['cellWidthControlSize'] || 0;
   setTimeout(() => {
    this.calendarConfig.modes = {
      day: {
        hourHeight: this.metaData?.calendar?.display?.business_hours_only ? 100 + (this.sliderHeightValue || 0) : (this.sliderHeightValue * 1.09) + 31,
        minDayWidth: this.sliderWidthValue ? (this.sliderWidthValue * 50) : 0,
        dayStartTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().start_time : '00:00:01',
        dayEndTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().end_time : '24:00:00',
        visibleStartTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().start_time : '00:00:01',
        hideNonWorkingDays: this.metaData?.calendar?.display?.weekends ? false : true,
        weekStartDay: this.metaData?.calendar?.display.weekStartDay,
      },
      week: {
        hourHeight: this.metaData?.calendar?.display?.business_hours_only ? 100 + (this.sliderHeightValue || 0) : (this.sliderHeightValue * 1.09) + 30,
        minDayWidth: this.sliderWidthValue ? (this.sliderWidthValue * 50) : 0,
        dayStartTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().start_time : '00:00:01',
        dayEndTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().end_time : '24:00:00',
        visibleStartTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().start_time : '00:00:01',
        hideNonWorkingDays: this.metaData?.calendar?.display?.weekends ? false : true,
        weekStartDay: this.metaData?.calendar?.display.weekStartDay,
      },
      month: {
        weekStartDay: this.metaData?.calendar?.display.weekStartDay,
        hideNonWorkingDays: this.metaData?.calendar?.display?.weekends ? false : true,
        showWeekNumber: this.metaData?.calendar?.display?.week_numbers
      }
    };
   }, 500);
  }

  preferredTimeZone(): string {
    return this._localStorageService.getLocalStorage('user_preferences')?.timezone ||
      this._localStorageService.getLocalStorage('company')?.company_timezone ||
      dayjs?.tz?.guess();
  }


  createNewJobEvent(dragData: any): void {
    this.createNewJob(dragData);
  }

  createNewJob(dragData: any): void {
    this._analytics.trackEvent('web_calendar_create_job_button_clicked');
    if (!this.checkPermission(this.companyConfig?.jobs?.allow_fe_create, 'job.new')) {
      return;
    }
    this.calendarFilterDrawerData.openFilter = false;
    this.openNewJobDrawer = true;
  }

  checkPermission(configPermission: boolean, utilityPermission: string): boolean {
    const currentUser = this._localStorageService.getLocalStorage('user');
    const isFieldExecutive = currentUser?.role?.role_key === 'FIELD_EXECUTIVE';
    if (isFieldExecutive) {
      if (currentUser?.access_role) {
        return this._utilityService.hasPermission(utilityPermission);
      } else {
        return configPermission;
      }
    } else {
      return this._utilityService.hasPermission(utilityPermission);
    }
  };

  getDispatchTimeZoneObj(): any {
    if (this.selectedTimeZone) {
      const selectedTimezone: any = this.allTimeZones?.find(value => this.selectedTimeZone === value?.key);
      return selectedTimezone || null;
    }
    return null;
  }

  jobFormEmitHandler(event: any): void {
    if (event?.isDrawerClosed) {
      this.openNewJobDrawer = false;
      this.cloneJobData = null;
      if (!event?.job_uid) {
        this._analytics.trackEvent('web_calendar_create_job_cancel_button_clicked');
      }
      if (this.createdJobId) {
        this.calendar?.eventStore?.remove(this.createdJobId);
        this.createdJobId = null;
      }
    }
    if (event.isCreatedJob) {
      this._analytics.trackEvent('web_calendar_create_job_create_button_clicked');
      this.updateNewJobData(this.getOriginalJobUid(event.job_uid));
    } else if (event?.action === 'ADVANCED_JOB' && event?.job) {
      this._analytics.trackEvent('web_calendar_create_detailed_job_button_clicked');
      const job: dataObj = { ...event?.job, action: 'clone', isDialog: true };
      const advancedJobService = this._zuperDialogService.openCustom(JobFormComponent, {
        data: job,
        extraClass: 'advanced-job-dialog'
      });
      advancedJobService.afterClosed()
        .subscribe((dialogData: any) => {
          if (dialogData?.job_uid) {
            this.updateNewJobData(dialogData.job_uid);
          }
        });
    }
  }

  updateNewJobData(jobUid: string): void {
    if (!this._utilityService.isEmptyOrUndefined(jobUid)) {
      const jobUrl = `${this._dispatchBoardService.jobDetailsUrl}/${jobUid}`;
      this._dataCollectorService.getData(jobUrl)
        .subscribe((response: any) => {
          this.getAllJobs(this.calendar.date);
          this.getEventCount(this.calendar.date);
        });
    }
  }

  getJobCategory(): any {
    this._dataCollectorService.getData(this.dispatchFilterService.filterAPIurls.jobCategoryUrl).subscribe((res: any): void => {
      this.jobsCategory = res['data'];
      this.jobsCategory.forEach((category: any) => category['selectedAllCategories'] = 'selectedAllCategories');
    });
  }

  getAllJobs(date, fromSelection?: boolean): any {
    this.loaded = false;
    const observables: any = {
      nonJobEventData: this.getNonJobEventDataObservable()
    };
    if (this.metaData?.calendar?.display?.show_timeoff) {
      observables.timeOffList = this.gettimeOffListObservable(this.getFilterParams()['from_date'], this.getFilterParams()['to_date']);
    }
    this.unsubscribeAll();
    this.forkJoinSubscription = forkJoin(observables).subscribe({
      next: () => {
        this.filteredSubscription = this._dataCollectorService.getData(this._dispatchBoardService.jobCalendarDataUrl, this.getFilterParams(date))
          .subscribe({
            next: (res: any): void => {
              this.loaded = true;
              res.data?.forEach((job) => {
                job.startDate = job.scheduled_start_time;
                job.endDate = job.scheduled_end_time;
                job.eventType = 'JOB';
              });
              this.jobsArrBackup = res.data;
              this.updateCalendarData(fromSelection);
              setTimeout(() => {
                this.disableModeTab = false;
              }, 300);
            },
            error: (error) => {
              this.loaded = true;
              this.disableModeTab = false;
            }
          });
      },
      error: (err) => {
        this.loaded = true;
        this.disableModeTab = false;
      }
    });
  }
  
  unsubscribeAll(): void {
    if (this.forkJoinSubscription) {
      this.forkJoinSubscription.unsubscribe();
    }
    if (this.filteredSubscription) {
      this.filteredSubscription.unsubscribe();
    }
  }

  updateCalendarData(fromSelection?: boolean): any{
    this.jobsArr = this.events = [];
    const jobs = _.cloneDeep(this.jobsArrBackup);
    if (this.calendarMode !== 'month') {
      this.jobsArr = this.events = this.splitJobs(jobs);
    } else {
      jobs?.forEach((job, index) => {
        job.id = job.job_uid;
        if (job.scheduled_start_time && job.scheduled_end_time) {
          job.startDate = moment.tz(job.scheduled_start_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
          job.endDate = moment.tz(job.scheduled_end_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
        }
        job.eventColor = '#3c763d';
        job.eventType = 'JOB';
        if (job.current_job_status && job.current_job_status.status_type === 'CLOSED') {
          job.resizable = false;
          job.draggable = false;
        }
      });
      this.jobsArr = this.events = jobs;
    }
    this.events.push(...this.holidays);
    if (this.metaData?.calendar?.display?.show_timeoff) {
      this.events.push(...this.timeOffList);
    }
    this.events.push(...this.calendarNonJobEvents);
    this.updateCalendarStore();
    if (fromSelection) {
      this.showCalendarPicker = true;
      this.miniCalendarHide = false;
      setTimeout(() => {
        this.getWeekNumber();
      }, 25);
    }
    this.activeDate = this.calendar.date;
    // this.events = this.jobsArr;
    this.updateMiniCalendarCss();
    this._dispatchBoardService.setCalendarRecords(this.jobsArr);
  }


  splitJobs(jobs): any {
    const modifiedJobs = [];

    for (const job of jobs) {
      job.id = job.job_uid;
      if (job.scheduled_start_time && job.scheduled_end_time) {
        job.startDate = moment.tz(job.scheduled_start_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
        job.endDate = moment.tz(job.scheduled_end_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
      }
      job.eventColor = '#3c763d';
      job.eventType = 'JOB';
      if (job.current_job_status && job.current_job_status.status_type === 'CLOSED') {
        job.resizable = false;
        job.draggable = false;
      }
      // Convert start and end times to preferred timezone
      const startDate = new Date(job.startDate);
      const endDate = new Date(job.endDate);
      if (startDate.toDateString() === endDate.toDateString()) {
        // Single-day job in the preferred timezone
        modifiedJobs.push(job);
      } else {
        // Multi-day job in the preferred timezone
        const splitJobs = this.splitMultiDayJob(job, startDate, endDate);
        modifiedJobs.push(...splitJobs);
      }
    }

    return modifiedJobs;
  }

  splitMultiDayJob(job, startDate, endDate): any {
    const splitJobs = [];
  
    const formatDateTime = (date) => {
      date = new Date(date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    };
  
    // Process the first day
    const firstDayEndTime = this.getMultiEndTime(startDate);
    const firstDayJob = { ...job };
    firstDayJob.startDate = formatDateTime(job.startDate);
    firstDayJob.endDate = formatDateTime(firstDayEndTime);
    firstDayJob.job_uid = `${job.job_uid}-${this.formatSplitJobDate(startDate)}`;
    firstDayJob.id = firstDayJob.job_uid;
    firstDayJob.resizable = false;
    splitJobs.push(firstDayJob);
  
    // Move currentDay to the next day after the first day
    let currentDay = new Date(startDate);
    currentDay.setDate(currentDay.getDate() + 1);
    while (currentDay < endDate) {
      const middleDayJob = { ...job };
      middleDayJob.startDate = formatDateTime(this.getMultiStartTime(currentDay));
      middleDayJob.endDate = formatDateTime(this.getMultiEndTime(currentDay));
      middleDayJob.job_uid = `${job.job_uid}-${this.formatSplitJobDate(currentDay)}`;
      middleDayJob.id = middleDayJob.job_uid;
      middleDayJob.resizable = false;
      splitJobs.push(middleDayJob);
      currentDay.setDate(currentDay.getDate() + 1);
      if (this.isLastDay(currentDay, endDate)) {
        break;
      }
    }
  
    // Process the last day
    const lastDayJob = { ...job };
    lastDayJob.startDate = formatDateTime(this.getMultiStartTime(endDate));
    lastDayJob.endDate = formatDateTime(job.endDate);
    lastDayJob.job_uid = `${job.job_uid}-${this.formatSplitJobDate(endDate)}`;
    lastDayJob.id = lastDayJob.job_uid;
    lastDayJob.resizable = false;
    splitJobs.push(lastDayJob);
  
    return splitJobs;
  }
  
  isLastDay(currentDay, endDate): boolean {
    const currentDateOnly = new Date(currentDay.getFullYear(), currentDay.getMonth(), currentDay.getDate());
    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    return currentDateOnly >= endDateOnly;
  }
  
  // Helper function to check if a day is between the start and end dates
  isMiddleDay(currentDay, endDate): boolean {
    const nextDay = new Date(currentDay);
    nextDay.setDate(nextDay.getDate() + 1);
    return nextDay < endDate;
  }  
  
  getMultiStartTime(date): any {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);  // Set time to 00:00:00
    return newDate;
  }
  
  getMultiEndTime(date): any {
    const newDate = new Date(date);
    newDate.setHours(23, 59, 59, 999);  // Set time to 23:59:59.999
    return newDate;
  }
  
  formatSplitJobDate(date: Date): string {
    date = new Date(date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}_${month}_${day}`;
  }

  getSingleEndTime(date, businessHours): any {
    const timeToCheck = moment(date.format('HH:mm:ss'), 'HH:mm:ss');
    const workStartTime = moment(businessHours.start_time, 'HH:mm:ss');
    const workEndTime = moment(businessHours.end_time, 'HH:mm:ss');

    if (timeToCheck.isBetween(workStartTime, workEndTime)) {
      return moment(date); // Return a moment object
    } else {
      return moment(date).set({
        'hour': workEndTime.get('hour'),
        'minute': workEndTime.get('minute'),
        'second': workEndTime.get('second'),
      });
    }
  }

  getSingleStartTime(date, businessHours): any {
    const timeToCheck = moment(date.format('HH:mm:ss'), 'HH:mm:ss');
    const workStartTime = moment(businessHours.start_time, 'HH:mm:ss');
    const workEndTime = moment(businessHours.end_time, 'HH:mm:ss');

    if (timeToCheck.isBetween(workStartTime, workEndTime)) {
      return moment(date); // Return a moment object
    } else {
      return moment(date).set({
        'hour': workStartTime.get('hour'),
        'minute': workStartTime.get('minute'),
        'second': workStartTime.get('second'),
      });
    }
  }



  getBusinessHours(): any {
    // Replace this with your actual logic to fetch business hours from the configuration
    const companyConfig = this._localStorageService.getLocalStorage('company_configuration_data');
    return companyConfig.business_hours;
  }




  onSliderValueChanged(event): any {
    let newValue = event.sliderValue;
    const localMetadata = this._localStorageService.getLocalStorage('calendar_metadata');
    const sliderType = event.sliderType;
    switch (sliderType) {
      case 'HEIGHT':
        this.sliderHeightValue = newValue;
        newValue = this.metaData?.calendar?.display?.business_hours_only ? 70 + newValue : newValue;
        this.calendarConfig.modes = {
          day: {
            hourHeight: (newValue * 1.09) + 31,
          },
          week: {
            hourHeight: (newValue * 1.09) + 30,
          }
        };
        if (localMetadata?.calendar?.display) {
          localMetadata.calendar.display['cellControlSize'] = this.sliderHeightValue;
          this._localStorageService.setLocalStorage('calendar_metadata', localMetadata);
        }
        this.debouncedTrackEvent('web_calendar_height_control_slider_adjusted');
        break;
      case 'WIDTH':
        this.sliderWidthValue = newValue;
        this.calendarConfig.modes = {
          day: {
            minDayWidth: this.sliderWidthValue * 50,
          },
          week: {
            minDayWidth: this.sliderWidthValue * 50,
          }
        };

        if (localMetadata?.calendar?.display) {
          localMetadata.calendar.display['cellWidthControlSize'] = this.sliderWidthValue;
          this._localStorageService.setLocalStorage('calendar_metadata', localMetadata);
        }
        this.debouncedTrackEvent('web_calendar_width_control_slider_adjusted');
        break;
    }
  }

  datePickerDateChange(event): void {
    if (event.value) {
      // this.showCalendarPicker = false;
      // this.miniCalDate = event.value;
    }
  }

  setEventCount(date): void {
    const { startDate, endDate } = this.getEventCountStartAndEndDate(date);
    const filterParams = this.getFilterParams();
    const eventParams: any = {
      module_name: 'JOB',
      from_date: startDate,
      to_date: endDate,
    };
    for (const [key, value] of Object.entries(filterParams)) {
      if (!['view', 'from_date', 'to_date'].includes(key)) {
        eventParams[`job_${key}`] = value;
      }
    }
    this._dataCollectorService.getEventCount(this._calendarService.eventsCountUrl, eventParams)
      .subscribe((response: any) => {
        this.eventCountArr = response['data'];
        this.eventCountMap = new Map();
        this.eventCountArr.forEach((item: any) => {
          const itemDate = moment(item['date']);
          const key = `${itemDate.year()}-${itemDate.month() + 1}-${itemDate.date()}`;
          this.eventCountMap.set(key, item['total']);
        });
        this.showCalendarPicker = true;
        this.activeDate = date;
        setTimeout(() => {
          const activeDateElement = document.querySelector('.b-today') as HTMLElement;
          if (activeDateElement) {
            const parentElement = activeDateElement.parentNode as Element;
            if (parentElement) {
              parentElement.classList.add('b-minical-active-week');
            }
          }
        }, 15);
        setTimeout(() => {
          const calendarWeekdays = document.querySelector('.b-calendar-weekdays') as HTMLElement;
          if (calendarWeekdays) {
            const weekNumberCell = calendarWeekdays.querySelector('.b-week-number-cell') as HTMLElement;
            if (weekNumberCell) {
              weekNumberCell.style.backgroundColor = 'white'; // Replace 'your-desired-color' with the actual color you want
            }
          }
          const elementWithRowIndex0 = document.querySelector('[data-row-index="0"]') as HTMLElement;
          const weekNumberCell0 = elementWithRowIndex0?.querySelector('.b-week-number-cell') as HTMLElement;
          weekNumberCell0?.classList.add('b-calendar-index-0');
          const elementWithRowIndex5 = document.querySelector('[data-row-index="5"]') as HTMLElement;
          const weekNumberCell1 = elementWithRowIndex5?.querySelector('.b-week-number-cell') as HTMLElement;
          weekNumberCell1?.classList.add('b-calendar-index-5');
        }, 10);
      },
      (error: any) => {
        this.eventCountArr = null;
        this.pickerConfig.showWeekNumber = this.metaData?.calendar?.display?.week_numbers;
        this.pickerConfig.hideNonWorkingDays = this.metaData?.calendar?.display?.weekends ? false : true;
        this.showCalendarPicker = true;
      });
  }

  onSelectionChange(event): void {
    if (event.selection) {
      this.showCalendarPicker = false;
      const isTrue = new Date(this.calendar?.date)?.getMonth() !== event?.selection[0].getMonth();
      if (isTrue) {
        this.getEventCount(event.selection[0]);
      }
      this.calendar.date = event.selection[0];
      this.getAllJobs(this.calendar.date, isTrue ? false : true);
    }

  }

  generateRandomNumbersForMonth(monthLength): any {
    const randomNumbers = [];
    for (let i = 0; i < monthLength; i++) {
      const randomNumber = Math.floor(Math.random() * 100);
      randomNumbers.push(randomNumber);
    }
    return randomNumbers;
  }


  toggleCalendar(show: boolean): void {
    this.showCalendarPicker = show;
    this.miniCalendarHide = !show;
    this.maxDivHeight = this.miniCalendarHide ? window.innerHeight - 138 : window.innerHeight - 480;
    this.updateMiniCalendarCss();
  }


  setDefaultConfig(): void {
    const _this = this;
    const timeFormat = this._utilityService.timeFormat;
    this.calendarConfig = {
      date: new Date(),
      onEventClick: (event: any): void => {
        const evntData = event?.eventRecord?.originalData;
        if (!evntData?.allDayEventType) {
          const jobUid = event?.eventRecord.originalData.job_uid;
          const eventType: 'JOB' | 'nonJobEvent' = evntData?.eventType === 'non_job_event' ? 'nonJobEvent': 'JOB';
          if(eventType === 'JOB'){
            if (jobUid) {
              _this._analytics.trackEvent('web_calendar_job_event_clicked');
              _this.calendarFilterDrawerData.openFilter = false;
              this._dispatchBoardService.jobPreview.next(_this.getOriginalJobUid(jobUid));
            }
          } else{
            const nonJobEventUid: string = evntData?.event_uid;
            if (nonJobEventUid) {
              _this.openNonJobEventPreview(nonJobEventUid);
            }
          }
        } else if (evntData?.allDayEventType === 'timeoff') {
          _this.editTimeOff(evntData);
        }
      },
      listeners: {
        // Async event listeners allowing you to veto drag operations
        beforeDragMoveEnd: ({ eventRecord, event, newStartDate, newEndDate }): any => {
          const preferredTimeZone = _this._utilityService.preferredTimeZone;
          const jobDetails = eventRecord.data;
          
          // Format newStartDate and newEndDate to strings in the 'YYYY-MM-DD HH:mm' format using native Date methods
          const formatDateTime = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
          };
        
          const startDateTime = formatDateTime(newStartDate);
          const endDateTime = formatDateTime(newEndDate);
          const [isHoliday, holidayName, blockJobsOnHoliday] = this._dispatchBoardService.isConflictWithHolidays(moment(startDateTime).clone(), moment(endDateTime).clone());
          if (blockJobsOnHoliday) {
            this.calendarHolidayDialogInstance = this.matDialog.open(this.calendarHolidayDialog, {
              panelClass: ['min-w-96'],
              disableClose: true,
              data: { showNewJob: this.permissions.newJob, showNewTimeoff: this.permissions.timesheetTimeoff, blockJobsOnHoliday: blockJobsOnHoliday, holidayName: holidayName }
            });
            return;
          }
        
          jobDetails['job_uid'] = _this.getOriginalJobUid(jobDetails['job_uid'] ?? jobDetails['realEventId']);
          const job_uid = _this.getOriginalJobUid(eventRecord.data['job_uid'] ?? eventRecord.data['realEventId']);
          const job: any = _.cloneDeep(_this.jobsArrBackup.filter((job) => job.job_uid === job_uid));
          let scheduleJobDetails;
        
          if (!jobDetails?.scheduled_end_time && !jobDetails?.scheduled_start_time) {
            _this._analytics.trackEvent('web_calendar_unscheduled_jobs_drag_and_drop');
            const businessHours = _this.getBusinessHours();
            const startTime = businessHours.start_time;
            const endTime = businessHours.end_time;
        
            // Manually combine formatted date and time into new Date objects
            const startDate = new Date(startDateTime);
            const endDate = new Date(endDateTime);
            startDate.setHours(Number(startTime.split(':')[0]), Number(startTime.split(':')[1]));
            endDate.setHours(Number(endTime.split(':')[0]), Number(endTime.split(':')[1]));
            if (_this.calendarMode === 'month') {
              jobDetails['scheduled_start_time'] =  moment.tz(startDate,preferredTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
              jobDetails['scheduled_end_time'] =  moment.tz(endDate,preferredTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            }
        
            scheduleJobDetails = {
              data: jobDetails,
              type: 'SCHEDULE',
              startDate: _this.calendarMode === 'month' ? startDate : moment.tz(startDateTime,preferredTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
              extraClass: 'update-schedule-date',
              trackEvent: { trigger: 'onScheduleJobSuccess', eventName: 'project_jobs_gantt_drag_and_drop_job' },
              module: calendarModule.CALENDAR
            };
          } else {
            _this._analytics.trackEvent('web_calendar_event_drag');
        
            const checkStartDate = new Date(job[0].scheduled_start_time);
            const checkEndDate = new Date(job[0].scheduled_end_time);
            if (checkStartDate.toDateString() === checkEndDate.toDateString()) {
              if (newStartDate) {
                jobDetails['scheduled_start_time'] = moment.tz(startDateTime,preferredTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
              }
              if (newEndDate) {
                jobDetails['scheduled_end_time'] =  moment.tz(endDateTime,preferredTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
              }
            } else {
              jobDetails['scheduled_start_time'] = moment.tz(startDateTime,preferredTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
              const durationMs = checkEndDate.getTime() - checkStartDate.getTime();
              const newEndTime = new Date(newStartDate.getTime() + durationMs);
              jobDetails['scheduled_end_time'] =  moment.tz(formatDateTime(newEndTime), preferredTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            }
            
            scheduleJobDetails = {
              data: jobDetails,
              type: 'edit',
              extraClass: 'update-schedule-date',
              module: calendarModule.CALENDAR,
              enableClearSchedule: true
            };
          }
        
          const scheduleDateDialog = this.zuperDialogService.openCustom(UpdateScheduledDateComponent, scheduleJobDetails);
          scheduleDateDialog.afterClosed().subscribe((response) => {
            if (response?.isUpdated) {
              _this._analytics.trackEvent('web_calendar_drag_to_schedule_reschedule_update_button_clicked');
              _this.getAllJobs(this.calendar.date);
              _this.getEventCount(this.calendar.date);
              _this.getGridData();
            } else {
              if (_this.canReschedule === 'continue') {
                _this._analytics.trackEvent('web_calendar_drag_to_schedule_reschedule_cancel_button_clicked');
              }
            }
          });
        },
        beforeDragResizeEnd: ({ eventRecord, newStartDate, newEndDate }): any => {
          const preferredTimeZone = this._utilityService.preferredTimeZone;
          const jobDetails = eventRecord.data;
          // Convert newStartDate and newEndDate to preferred timezone
          const formatDateTime = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
          };
        
          const startDateTime = formatDateTime(newStartDate);
          const endDateTime = formatDateTime(newEndDate);

          // Extract user information
          jobDetails['job_uid'] = _this.getOriginalJobUid(jobDetails['job_uid']);

          // Convert newStartDate and newEndDate to UTC
          if (newStartDate) {
            jobDetails['scheduled_start_time'] = moment.tz(startDateTime,preferredTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
          }
          if (newEndDate) {
            jobDetails['scheduled_end_time'] = moment.tz(endDateTime,preferredTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
          }

          // Open dialog with updated data
          const scheduleDateDialog = _this.zuperDialogService.openCustom(UpdateScheduledDateComponent, {
            data: jobDetails,
            type: 'edit',
            extraClass: 'update-schedule-date',
            module: calendarModule.CALENDAR,
            enableClearSchedule: true
          });

          scheduleDateDialog.afterClosed().subscribe((response) => {
            if (response?.isUpdated) {
              _this._analytics.trackEvent('web_calendar_drag_to_schedule_reschedule_update_button_clicked');
              _this.getAllJobs(this.calendar.date);
              _this.getEventCount(this.calendar.date);
            } else {
              _this._analytics.trackEvent('web_calendar_drag_to_schedule_reschedule_cancel_button_clicked');
            }
          });
        },
        beforeDragCreateEnd: ({ eventRecord, resourceRecord, newStartDate, newEndDate }): any => {
          if (!_this.checkPermission(_this.companyConfig?.jobs?.allow_fe_create, 'job.new')) {
            return false;
          }
          _this._analytics.trackEvent('web_calendar_drag_to_create_job');
          const preferredTimeZone = this._utilityService.preferredTimeZone;
          const formatDateTime = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
          };
          const startDateTime = formatDateTime(newStartDate);
          let endDateTime: any = formatDateTime(newEndDate);
          _this.createdJobId = eventRecord.data.id;
          const [isHoliday, holidayName, blockJobsOnHoliday] = this._dispatchBoardService.isConflictWithHolidays(moment(startDateTime).clone(), moment(endDateTime).clone());

          const businessHours = _this.getBusinessHours();
          let combinedStartDateTime;
          let combinedEndDateTime;
          let dragData = {};
          if (_this.calendarMode === 'month') {
            endDateTime = moment(endDateTime).clone().subtract(1, 'days');
            let startTime: moment.Moment | string = businessHours.start_time;
            let endTime: moment.Moment | string = businessHours.end_time;
            if (!(startTime instanceof moment)) {
              startTime = moment(startTime, 'HH:mm:ss');
            }
            if (!(endTime instanceof moment)) {
              endTime = moment(endTime, 'HH:mm:ss');
            }
            combinedStartDateTime = moment({
              year: moment(startDateTime).year(),
              month: moment(startDateTime).month(),
              day: moment(startDateTime).date(),
              hour: (startTime as moment.Moment).hour(),
              minute: (startTime as moment.Moment).minute(),
              second: (startTime as moment.Moment).second()
            });
            combinedEndDateTime = moment({
              year: moment(endDateTime).year(),
              month: moment(endDateTime).month(),
              day: moment(endDateTime).date(),
              hour: (endTime as moment.Moment).hour(),
              minute: (endTime as moment.Moment).minute(),
              second: (endTime as moment.Moment).second()
            });
            dragData = { startDate: combinedStartDateTime, endDate: combinedEndDateTime };
          } else {
            const startDateTime = dayjs(newStartDate).tz(preferredTimeZone, true);
            const endDateTime = dayjs(newEndDate).tz(preferredTimeZone, true);
            const newStartDateTime = dayjs(newStartDate).tz(preferredTimeZone, true);
            const newEndDateTime = dayjs(newEndDate).tz(preferredTimeZone, true);
            dragData = { startDate: startDateTime.toISOString(), startTime: newStartDateTime.format('HH:mm:ss'), endDate: endDateTime.toISOString(), endTime: newEndDateTime.format('HH:mm:ss') };
          }
          if (blockJobsOnHoliday) {
            this.calendarHolidayDialogInstance = this.matDialog.open(this.calendarHolidayDialog, {
              panelClass: ['min-w-96'],
              disableClose: true,
              data: { showNewJob: this.permissions.newJob, showNewTimeoff: this.permissions.timesheetTimeoff, dragData: dragData, blockJobsOnHoliday: blockJobsOnHoliday, holidayName: holidayName }
            });
            return;
          }
          if (_this._utilityService.isEmptyOrUndefined(dragData)) {
            _this.newJobPrefillData = {};
          }
          else {
            _this.newJobPrefillData = dragData;
          }
          _this.openNewJobDrawer = true;
        },
      },
      features: {
        eventEdit: null,
        scheduleMenu: {
          items: {
            addEvent: false,
            editEvent: false
          }
        },
        externalEventSource: {
          grid: 'grid-card-view',
          droppable: true,
        },
        eventMenu: {
          processItems: (context: any): any => {
            const items: any = context.items;
            const isAlldayevent = context?.eventRecord?.allDay;
            if(isAlldayevent){
              return !isAlldayevent;
            }
            const eventDetails: any = context?.eventRecord?.data;
            const eventType: 'JOB' | 'nonJobEvent' = eventDetails?.eventType === 'non_job_event' ? 'nonJobEvent': 'JOB';
            if (eventType === 'nonJobEvent') {
              items.clearSchedule.hidden = true;
              items.reschedule.hidden = true;
              items.cloneJob.hidden = true;
              items.newNote.hidden = true;
              items.deleteJob.hidden = true;
              items.editNonJobEvent.hidden = false;
              items.deleteNonJobEvent.hidden = false;
            }
            else if (eventType === 'JOB') {
              items.clearSchedule.hidden = false;
              items.reschedule.hidden = false;
              items.cloneJob.hidden = false;
              items.newNote.hidden = false;
              items.deleteJob.hidden = false;
              items.editNonJobEvent.hidden = true;
              items.deleteNonJobEvent.hidden = true;
            }
          },
          items: {
            copyEvent: false,
            cutEvent: false,
            editEvent: false,
            deleteEvent: false,
            unassignEvent: false,
            splitEvent: false,
            duplicate: false,

            reschedule: {
              text: this._utilityService.getLocaleValue('text.reschedule_job', 'Reschedule Job'),
              weight: 300,
              icon: 'ti ti-clock-edit text-xl',
              cls: 'primary-font leading-normal text-base text-gray-700',
              onItem: (event: any): any => {
                _this._analytics.trackEvent('web_calendar_right_click_reschedule');
                const jobUid = event.eventRecord?.data?.job_uid;
                event.eventRecord.data['job_uid'] = _this.getOriginalJobUid(jobUid);
                const scheduleDateDialog = this.zuperDialogService.openCustom(UpdateScheduledDateComponent, {
                  data: event.eventRecord?.data,
                  type: 'edit',
                  extraClass: 'update-schedule-date',
                  module: calendarModule.CALENDAR,
                  enableClearSchedule: true
                });
                scheduleDateDialog.afterClosed().subscribe((result: any) => {
                  if (result?.isUpdated) {
                    _this._analytics.trackEvent('web_calendar_drag_to_schedule_reschedule_update_button_clicked');
                    _this.getAllJobs(this.calendar.date);
                    _this.getEventCount(this.calendar.date);
                  } else {
                    _this._analytics.trackEvent('web_calendar_drag_to_schedule_reschedule_cancel_button_clicked');
                  }
                });
              },
              disabled: !this.checkPermission(this.companyConfig?.jobs?.allow_fe_reschedule, 'job.reschedule')
            },
            clearSchedule: {
              text: this._utilityService.getLocaleValue('text.clear_schedule', 'Clear Schedule'),
              weight: 300,
              icon: 'ti ti-eraser text-xl',
              cls: 'primary-font leading-normal text-base text-gray-700',
              onItem: (event: any): any => {
                _this._analytics.trackEvent('web_calendar_right_click_clear_schedule_clicked');
                const jobDetails = event.eventRecord?.data;
                const jobUid = jobDetails?.job_uid;
                jobDetails['job_uid'] = _this.getOriginalJobUid(jobUid);

                if (jobDetails?.due_date) {
                  const clearScheduleConfirmationDialogRef = _this._calendarService.jobDetailsChangeConfirmationDialog(jobDetails, 'clearSchedule');
                  clearScheduleConfirmationDialogRef.afterClosed()
                    .subscribe((result: boolean) => {
                      if (result) {
                        _this._calendarService.clearScheduleJob(jobDetails, (status: true) => {
                          if (status) {
                            _this.getAllJobs(this.calendar.date);
                            _this.getEventCount(this.calendar.date);
                          }
                        });
                      }
                    });
                }
                else {
                  const dueDateDialog = _this._zuperDialogService.openCustom(UpdateDueDateComponent, {
                    data: jobDetails,
                    extraClass: 'w-2/5',
                    clearSchedule: true, //prefill checkbox based in the value
                    updateDueDateAndClearSchedule: true //change primary button text and add note on top
                  });

                  dueDateDialog.afterClosed().subscribe((response: any) => {
                    if (response) {
                      if (jobDetails?.route?.route_uid) {
                        _this._calendarService.clearScheduleJobFromRoute(jobDetails, (status: true) => {
                          if (status) {
                            _this.getAllJobs(this.calendar.date);
                            _this.getEventCount(this.calendar.date);
                          }
                        });
                      }
                      else {
                        _this.getAllJobs(this.calendar.date);
                        _this.getEventCount(this.calendar.date);
                      }
                    }
                  });
                }
              },
            },
            newNote: {
              text: this._utilityService.getLocaleValue('dispatchBoard.scheduler.event_menu.options.note', 'New Note'),
              weight: 300,
              icon: 'ti ti-notes text-xl',
              cls: 'primary-font leading-normal text-base text-gray-700',
              onItem: (event: any): any => {
                _this._analytics.trackEvent('web_calendar_right_click_new_note_clicked');
                const jobUid = event.eventRecord.originalData?.job_uid;
                event.eventRecord.originalData['job_uid'] = _this.getOriginalJobUid(jobUid);
                const jobDetails = event.eventRecord.originalData;
                _this._dispatchBoardService.setMultiModulePickerTabs(jobDetails['job_uid']);
                const editNoteDialog = _this._zuperDialogService.openCustom(NoteDialogComponent,
                  {
                    extraClass: 'note-dialog-file-uploader',
                    data: {
                      header: {
                        titleDisplayKey: 'add.note.text',
                        titleDisplayName: 'Add Note'
                      },
                      footer: {
                        submitDisplayKey: 'add.note.text',
                        submitDisplayName: 'Add Note',
                        closeDisplayKey: 'close.text',
                        closeDisplayName: 'Close',
                        enablePrivacy: true
                      },
                      defaultAssociatedModule: 'JOB',
                      defaultAssociatedModuleDetails: jobDetails,
                      config: {
                        editorOptions: {
                          isEnabled: true,
                          options: {
                            imageUpload: false,
                            allowMentions: true,
                            showTemplate: false,
                            editorId: 'note_text_editor',
                            module: 'JOB',
                            placeholder: _this._utilityService.getLocaleValue('notes.panel.editor.placeholder'),
                            initUponFocus: null,
                            addAttachmentsInBody: false
                            , ...{ editorId: 'edit_note_text_editor' }
                          }
                        },
                        uploaderOptions: {
                          isEnabled: true,
                          options: {
                            uploadFileFor: 'NOTE',
                            multiple: true,
                            setMaxLimit: true,
                            attachmentType: 'JOB_NOTE',
                            showProgress: false,
                            showPreview: false,
                            description: {
                              descriptionKey: 'notes.panel.attachment.description',
                              descriptionName: 'Supported Files: Image, Video, Audio, PDF, DOC, XLS'
                            }
                          }
                        }
                      }
                    }
                  });

                editNoteDialog.disableClose = true;
                const onSubmitClicked = _this._noteDialogService.onSubmitClicked.subscribe((response: any) => {
                  editNoteDialog.close(response);
                });
                editNoteDialog.afterClosed().subscribe((result: any) => {
                  if (!_this._utilityService.isEmptyOrUndefined(result)) {
                    const payload = { ...result, jobUid: jobUid };
                    _this._dispatchBoardService.createNewNote(payload);
                    onSubmitClicked.unsubscribe();
                    _this.getAllJobs(this.calendar.date);
                    _this.getEventCount(this.calendar.date);
                  }

                });
              }
            },
            cloneJob: {
              text: this._utilityService.getLocaleValue('calendar.event_menu.options.clone', 'Clone'),
              weight: 300,
              icon: 'ti ti-copy text-xl',
              cls: 'primary-font leading-normal text-base text-gray-700',
              onItem: (event: any): any => {
                _this._analytics.trackEvent('web_calendar_right_click_clone_clicked');
                const jobUid = event.eventRecord.originalData?.job_uid;
                event.eventRecord.originalData['job_uid'] = _this.getOriginalJobUid(jobUid);
                const jobDetails = event.eventRecord.originalData;
                _this.cloneJob(jobDetails);
              },
              disabled: !this._utilityService.hasPermission('job.clone'),
            },
            deleteJob: {
              text: this._utilityService.getLocaleValue('calendar.event_menu.options.delete_job', 'Delete Job'),
              cls: 'text-red-600 primary-font leading-normal text-base b-t-1',
              weight: 300,
              icon: 'ti ti-trash text-xl text-red-600',
              onItem: (event: any): any => {
                _this._analytics.trackEvent('web_calendar_right_click_delete_clicked');
                const jobDetails = event.eventRecord.originalData;
                jobDetails['job_uid'] = _this.getOriginalJobUid(jobDetails['job_uid']);
                const jobUid = jobDetails?.job_uid;
                const deleteConfirmationDialogRef = _this._calendarService.jobDetailsChangeConfirmationDialog(jobDetails, 'delete');
                deleteConfirmationDialogRef.afterClosed()
                  .subscribe((result: boolean) => {
                    if (result) {
                      _this._calendarService.deleteJob(jobUid, (status: true) => {
                        if (status) {
                          _this.getAllJobs(this.calendar.date);
                          _this.getEventCount(this.calendar.date);
                        }
                      });
                    }
                  });
              },
              disabled: !this._utilityService.hasPermission('job.delete'),
            },
            editNonJobEvent: {
              text: this._utilityService.getLocaleValue('edit', 'Edit'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-edit text-xl',
              onItem: (event: any): any => {
                const eventDetails = event.eventRecord.originalData;
                this.nonJobEventCreateDrawerData.source = null;
                this.editNonJobEvent(eventDetails);
              }
            },
            deleteNonJobEvent: {
              text: this._utilityService.getLocaleValue('delete.text', 'Delete'),
              cls: 'text-red-600 primary-font leading-normal text-base b-t-1',
              weight: 300,
              icon: 'ti ti-trash text-xl text-red-600',
              onItem: (event: any): any => {
                const nonJobEventDetails = event.eventRecord.originalData;
                const nonJobEventUid = nonJobEventDetails?.event_uid;
                nonJobEventDetails['startEndDateTime'] = this._dispatchBoardService.getStartEndTime(nonJobEventDetails?.start_time, nonJobEventDetails?.end_time, false, null, false, false, this.selectedTimeZone);
                if (nonJobEventUid && nonJobEventDetails) {
                  let deleteParam: any = {};
                  if (nonJobEventDetails?.is_recurrence) {
                    const eventName: string = nonJobEventDetails?.event_name;
                    const actionSelectorOption: ActionSelectorOption = {
                      title: `${this._utilityService.getLocaleValue('non_job_event.recurrence.delete.title', 'Delete Recurring Non Job Event')} - ${eventName}`,
                      options: [
                        {
                          key: 'SINGLE_EVENT',
                          optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.delete.event_only_title', 'Delete this event only'),
                          optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.event_only_message', 'Applies to this event only')} (${nonJobEventDetails?.startEndDateTime[0]})`
                        },
                        {
                          key: 'ALL_FUTURE_EVENTS',
                          optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.delete.upcoming_event_title', 'Delete this and upcoming events'),
                          optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.upcoming_event_message', 'Applies to this and upcoming events in the series.')}`
                        }
                      ],
                      primaryActionButtonText: this._utilityService.getLocaleValue('delete.text', 'Delete'),
                      primaryActionButtonType: 'error'
                    };
                    const actionSelectorDialogRef = this._zuperDialogService.openCustom(ActionSelectorComponent, { data: actionSelectorOption, extraClass: 'non-job-delete-recurrence-dialog' });
                    actionSelectorDialogRef.afterClosed().subscribe((response: any) => {
                      if (response?.isSelected) {
                        if (response?.selectedType) {
                          deleteParam['delete_recurrence_type'] = response?.selectedType;
                        }
                        else {
                          deleteParam = {};
                        }
                        this._dispatchBoardService.deleteNonJobEvent(nonJobEventUid, deleteParam, (deleteStatus: boolean) => {
                          if (deleteStatus) {
                            this._analytics.trackEvent('non_job_event_deleted');
                            this.getNonJobEventData(true);
                          }
                        });
                      }
                    });
                  } else {
                    const deleteDialogRef = this._dispatchBoardService.nonJobEventDetailsChangeConfirmationDialog(nonJobEventDetails, 'delete');
                    deleteDialogRef.afterClosed().subscribe((status: boolean) => {
                      if (status) {
                        this._dispatchBoardService.deleteNonJobEvent(nonJobEventUid, deleteParam, (deleteStatus: boolean) => {
                          if (deleteStatus) {
                            this._analytics.trackEvent('non_job_event_deleted');
                            this.getNonJobEventData(true);
                          }
                        });
                      }
                    });
                  }
                }
              }
            },
          },
        },
        eventTooltip: {
          showOn: 'hover',
          revealEventsInCluster: false,
          renderer: ({ eventRecord, element }): any => {
            if(eventRecord['originalData']['allDay']){
              element.classList.remove('non-job-event');
              return _this._templateService.getAllDayEventTemplate(eventRecord['originalData'].allDayEventType, eventRecord['originalData']);
            } else {
              const eventType: 'JOB' | 'nonJobEvent' = eventRecord['originalData']['eventType'] === 'non_job_event' ? 'nonJobEvent': 'JOB';
              if(eventType === 'JOB'){
                element.classList.remove('non-job-event');
                return _this._templateService.getJobDetailsTemplate(eventRecord['originalData'], 'day', this.metaData);
              } else{
                element.classList.add('non-job-event');
                return _this._templateService.getNonJobEventTooltip(eventRecord['originalData']);
              }
            }
          }
        },
      },
      modeDefaults: {
        // Allows us to see details in a crowded day
        zoomOnMouseWheel: false,
      },
      tbar: {
        hidden: true,
      },
      modes: {
        year: false,
        month: {
          overflowPopup: {
            footer: {
              dock: 'bottom',
              html: `<div class="calendar-month-overflow-footer"><span class="align-middle"><em class="ti ti-arrow-narrow-right pt-3 text-xl mx-1"></em></span><a class="hover:underline">${this._utilityService.getLocaleValue('text.calendar.mode.view_day', 'View Day')}</a></div>`,
              cls: 'b-header-title text-center text-base cursor-pointer text-orange-600 bg-color-white border-t border-gray-200 primary-font font-semibold'
            },
            header: {
              cls: 'calendar-month-overflow-header bg-color-white text-center text-base text-orange-600 primary-font font-semibold'
            },
            eventRenderer: ({ eventRecord, renderData }): any => {
              const jobDetails = eventRecord['data'];
              if (jobDetails.allDay) {
                renderData.eventColor = jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6';
                renderData.style = {
                  backgroundColor: jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6'
                };
                return _this._templateService.getTimeOffHolidayTemplate(jobDetails.allDayEventType, jobDetails);
              } else {
                const jobUid = _this.getOriginalJobUid(jobDetails?.job_uid);
                const eventType: 'JOB' | 'nonJobEvent' = jobDetails?.eventType === 'non_job_event' ? 'nonJobEvent': 'JOB';
                if(eventType === 'JOB'){
                  const eventBorderColor = _this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.secondary_color);
                  renderData.eventColor = `${_this._utilityService.convertHexToRgba(_this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.primary_color) || '#887ECB', '0.3')}`;
                  // eslint-disable-next-line max-len
                  renderData.style = {
                    borderWidth: _this.metaData?.calendar.primary_color === 'none' ? '2.5px' : '',
                    borderColor: 'rgba(210, 200, 200, 0.3)',
                    borderLeftWidth: '5px',
                    borderLeftColor: eventBorderColor || '#e67e22',
                    backgroundColor: _this._utilityService.convertHexToRgba(_this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.primary_color) || '#887ECB', '0.3')
                  };
                  return _this._templateService.getJobRendererTemplate('jobs', 'calendar', jobUid, jobDetails, 'month');
                }  else if (eventType === 'nonJobEvent') {
                  renderData.cls = {
                    ...renderData.cls,
                    'tentative-event': true,
                    'rounded-r-lg': true,
                    'border-gray-300': true,
                    'border-l-0': true,
                    'non-job-event-month': true
                  };
                  renderData.style = {
                    backgroundColor: 'rgba(245, 247, 249, 5)'
                  };
                  return _this._templateService.getNonJobEventRendererTemplate(jobDetails, 'MONTH');
                }
              }
            },
          },
          overflowButtonRenderer: (domConfig, overflowCount): any => {
            domConfig.className = {
              ...domConfig.className,
              'text-orange-600': 2,
              'primary-font': 3,
              'font-medium': 4,
              'text-base': 5
            };
            domConfig.text = 'Show more';
            return overflowCount ? domConfig : false;
          },
          onShowOverflowPopup: (): any => {
            _this._analytics.trackEvent('web_calendar_month_view_view_more_button_clicked');
          },
          showWeekColumn: true,
          showWeekNumber: true,
          eventRenderer({ eventRecord, renderData }): any {
            const jobDetails = eventRecord['data'];
            if (jobDetails.allDay) {
              renderData.eventColor = jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6';
              renderData.style = {
                backgroundColor: jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6'
              };
              return _this._templateService.getTimeOffHolidayTemplate(jobDetails.allDayEventType, jobDetails);
            } else {
              const jobUid = _this.getOriginalJobUid(jobDetails?.job_uid);
              const eventType: 'JOB' | 'nonJobEvent' = jobDetails?.eventType === 'non_job_event' ? 'nonJobEvent': 'JOB';
              if(eventType === 'JOB'){
                const eventBorderColor = _this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.secondary_color);

                if (_this.calendarMode === 'week') {
                  const { start, end, startMonth, endMonth, startYear, endYear } = _this.getStartEndWeekAndMonth(this.calendar.date);
                  if (startYear !== endYear) {
                    _this.selectedDate = `${startMonth} ${start}, ${startYear} - ${endMonth} ${end}, ${endYear}`;
                  } else {
                    _this.selectedDate = `${startMonth} ${start} - ${endMonth} ${end}, ${endYear}`;
                  }
                  _this.selectedMonth = DateHelper.format(this.calendar.date ? new Date(this.calendar.date) : new Date(), 'MMMM YYYY');
                  _this.getWeekNumber();
                }
                if (_this.calendarMode === 'month') {
                  _this.selectedDate = DateHelper.format(this.calendar.date ? new Date(this.calendar.date) : new Date(), 'MMM YYYY');
                  _this.selectedMonth = DateHelper.format(this.calendar.date ? new Date(this.calendar.date) : new Date(), 'MMMM YYYY');
                  _this.getWeekNumber();
                };
                // eslint-disable-next-line max-len
                renderData.eventColor = `${_this._utilityService.convertHexToRgba(_this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.primary_color) || '#887ECB', '0.3')}`;
                // eslint-disable-next-line max-len
                renderData.style = {
                  borderWidth: _this.metaData?.calendar.primary_color === 'none' ? '2.5px' : '',
                  borderColor: 'rgba(210, 200, 200, 0.3)',
                  borderLeftWidth: '5px',
                  borderLeftColor: eventBorderColor || '#e67e22',
                  backgroundColor: _this._utilityService.convertHexToRgba(_this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.primary_color) || '#887ECB', '0.3')
                };
                return _this._templateService.getJobRendererTemplate('jobs', 'calendar', jobUid, jobDetails, 'month');
              }  else if (eventType === 'nonJobEvent') {
                renderData.cls = {
                  ...renderData.cls,
                  'tentative-event': true,
                  'rounded-r-lg': true,
                  'border-gray-300': true,
                  'border-l-0': true,
                  'non-job-event-month': true
                };
                renderData.style = {
                  backgroundColor: 'rgba(245, 247, 249, 5)'
                };
                return _this._templateService.getNonJobEventRendererTemplate(jobDetails, 'MONTH');
              }
            }
          },
          dayCellRenderer: (cellData, dayCellDomConfig): any => {
            const currentMonth = cellData['date'].getMonth() + 1;
            const currentYear = cellData['date'].getFullYear();
            const formattedDate = `${currentYear}-${currentMonth}-${cellData['date'].getDate()}`;
            if (_this.eventCountMap) {
              const total = _this.eventCountMap.get(formattedDate);
              const eventCount = { className: 'month-view-event-count', html: total || 0 };
              dayCellDomConfig.children.push(eventCount);
            }
            // You can return dayCellDomConfig, or modify it further as needed
            return dayCellDomConfig;
          },
          height: window.innerHeight - 180,

        },
        week: {
          dayHeaderRenderer: (dayCellDomConfig, cellData): any => {
            const currentMonth = cellData.date.getMonth() + 1;
            const currentYear = cellData.date.getFullYear();
            const formattedDate = `${currentYear}-${currentMonth}-${cellData.date.getDate()}`;
            if (_this.eventCountMap) {
              const total = _this.eventCountMap.get(formattedDate);
              const eventCount = { className: 'b-event-count-view', html: total || 0 };
              dayCellDomConfig.children.push(eventCount);
            }
            return dayCellDomConfig;
          },
          timeAxisTimeFormat: timeFormat === 'hh:mm A' ?  ' h:mm A' : '  H:mm',
          timeFormat: timeFormat === 'hh:mm A' ?  'h:mm A' : 'H:mm',
          horizontalScroller: true,
          minDayWidth: this.sliderWidthValue ? (this.sliderWidthValue * 50) : 0,
          allDayEvents: {
            defaultEventRowCount: 2,
            disabled: true,
            draggable: false,
            overflowPopup: {
              header: {
                cls: 'calendar-month-overflow-header bg-color-white text-center text-base text-orange-600 primary-font font-semibold'
              },
              eventRenderer: ({ eventRecord, renderData }): any => {
                const jobDetails = eventRecord['data'];
                const jobUid = _this.getOriginalJobUid(jobDetails?.job_uid);
                const eventType: 'nonJobEvent' | '' = jobDetails?.eventType === 'non_job_event' ? 'nonJobEvent': '';
                if (eventType === 'nonJobEvent') {
                  renderData.cls = {
                    ...renderData.cls,
                    'tentative-event': true,
                    'rounded-r-lg': true,
                    'border-gray-300': true,
                    'border-l-0': true,
                    'non-job-event': true
                  };
                  renderData.style = {
                    backgroundColor: 'rgba(245, 247, 249, 5)'
                  };
                  return _this._templateService.getNonJobEventRendererTemplate(jobDetails, 'MONTH');
                } else {

                  renderData.eventColor = jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6';
                  renderData.style = {
                    backgroundColor: jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6'
                  };
                  return _this._templateService.getTimeOffHolidayTemplate(jobDetails.allDayEventType, jobDetails);
                }
            },
          }
         },
          nonWorkingDays: {
            0: true, // Sunday
            6: true  // Saturday
          },
          eventLayout: {
            clearanceMinutes: 1440,
          },
          dayStartTime: _this.metaData?.calendar?.display?.business_hours_only ? _this.getBusinessHours().start_time : '00:00:01',
          dayEndTime: _this.metaData?.calendar?.display?.business_hours_only ? _this.getBusinessHours().end_time : '24:00:00',
          visibleStartTime: _this.metaData?.calendar?.display?.business_hours_only ? _this.getBusinessHours().start_time : '00:00:01',
          eventRenderer({ eventRecord, renderData }): any {
            const jobDetails = eventRecord['data'];
            if (jobDetails.allDay) {
              renderData.eventColor = jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6';
              renderData.style = {
                backgroundColor: jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6'
              };
              return _this._templateService.getTimeOffHolidayTemplate(jobDetails.allDayEventType, jobDetails);
            } else {
              const eventType: 'JOB' | 'nonJobEvent' = jobDetails?.eventType === 'non_job_event' ? 'nonJobEvent': 'JOB';
              if(eventType === 'JOB'){
                const jobUid = _this.getOriginalJobUid(jobDetails?.job_uid);
                const eventBorderColor = _this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.secondary_color);
                if (_this.calendarMode === 'week') {
                  const { start, end, startMonth, endMonth, startYear, endYear } = _this.getStartEndWeekAndMonth(this.calendar.date);
                  if (startYear !== endYear) {
                    _this.selectedDate = `${startMonth} ${start}, ${startYear} - ${endMonth} ${end}, ${endYear}`;
                  } else {
                    _this.selectedDate = `${startMonth} ${start} - ${endMonth} ${end}, ${endYear}`;
                  }
                  _this.selectedMonth = DateHelper.format(this.calendar.date ? new Date(this.calendar.date) : new Date(), 'MMMM YYYY');
                  _this.getWeekNumber();
                }
  
                renderData.eventColor = `${_this._utilityService.convertHexToRgba(_this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.primary_color) || '#887ECB', '0.3')}`;
                renderData.style = {
                  borderWidth: _this.metaData?.calendar.primary_color === 'none' ? '2.5px' : '',
                  borderColor: _this.metaData?.calendar.primary_color === 'none' ? 'rgba(210, 200, 200, 0.3)' : '',
                  borderLeftWidth: '5px',
                  borderLeftColor: eventBorderColor || '#e67e22',
                  backgroundColor: _this._utilityService.convertHexToRgba(_this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.primary_color) || '#887ECB', '0.3')
                };
                return _this._templateService.getJobRendererTemplate('jobs', 'calendar', jobDetails?.job_uid, eventRecord['originalData'], 'week');
              }  else if (eventType === 'nonJobEvent') {
                renderData.cls = {
                  ...renderData.cls,
                  'tentative-event': true,
                  'rounded-r-lg': true,
                  'border-gray-300': true,
                  'border-l-0': true,
                  'non-job-event': true
                };
                renderData.style = {
                  backgroundColor: 'rgba(245, 247, 249, 5)'
                };
                return _this._templateService.getNonJobEventRendererTemplate(jobDetails, 'WEEK');
              }
            }
          },
          height: window.innerHeight - 180,
        },
        day: {
          nonWorkingDays: {
            0: true, // Sunday
            6: true  // Saturday
          },
          timeAxisTimeFormat: timeFormat === 'hh:mm A' ?  ' h:mm A' : '  H:mm',
          timeFormat: timeFormat === 'hh:mm A' ?  'h:mm A' : 'H:mm',
          allDayEvents: {
            fullWeek: false,
            defaultEventRowCount: 2,
            disabled: true,
            draggable: false,
            overflowPopup: {
              header: {
                cls: 'calendar-month-overflow-header bg-color-white text-center text-base text-orange-600 primary-font font-semibold'
              },
              eventRenderer: ({ eventRecord, renderData }): any => {
                const jobDetails = eventRecord['data'];
                renderData.eventColor = jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6';
                renderData.style = {
                  backgroundColor: jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6'
                };
                return _this._templateService.getTimeOffHolidayTemplate(jobDetails.allDayEventType, jobDetails);
              },
            }
          },
          horizontalScroller: true,
          minDayWidth: this.sliderWidthValue ? (this.sliderWidthValue * 50) : 0,
          eventLayout: {
            clearanceMinutes: 1440,
          },
          dayStartTime: _this.metaData?.calendar?.display?.business_hours_only ? _this.getBusinessHours().start_time : '00:00:01',
          dayEndTime: _this.metaData?.calendar?.display?.business_hours_only ? _this.getBusinessHours().end_time : '24:00:00',
          visibleStartTime: _this.metaData?.calendar?.display?.business_hours_only ? _this.getBusinessHours().start_time : '00:00:01',
          eventRenderer({ eventRecord, renderData }): any {
            const jobDetails = eventRecord['data'];
            if (jobDetails.allDay) {
              renderData.eventColor = jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6';
              renderData.style = {
                backgroundColor: jobDetails.allDayEventType === 'timeoff' ? _this._templateService.getTimeoffStatus(jobDetails) : '#3B82F6'
              }
              return _this._templateService.getTimeOffHolidayTemplate(jobDetails.allDayEventType, jobDetails);
            } else {
              const eventType: 'JOB' | 'nonJobEvent' = jobDetails?.eventType === 'non_job_event' ? 'nonJobEvent': 'JOB';
              if(eventType === 'JOB'){
                if (_this.calendarMode === 'day') {
                  _this.selectedDate = DateHelper.format(this.calendar.date ? new Date(this.calendar.date) : new Date(), 'MMM DD, YYYY');
                  _this.selectedMonth = DateHelper.format(this.calendar.date ? new Date(this.calendar.date) : new Date(), 'MMMM YYYY');
                  _this.getWeekNumber();
                };
                const jobDetails = eventRecord['data'];
                const jobUid = _this.getOriginalJobUid(jobDetails?.job_uid);
                const eventBorderColor = _this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.secondary_color);
                if (_this.calendarMode === 'week') {
                  const { start, end, startMonth, endMonth, startYear, endYear } = _this.getStartEndWeekAndMonth(this.calendar.date);
                  if (startYear !== endYear) {
                    _this.selectedDate = `${startMonth} ${start}, ${startYear} - ${endMonth} ${end}, ${endYear}`;
                  } else {
                    _this.selectedDate = `${startMonth} ${start} - ${endMonth} ${end}, ${endYear}`;
                  }
                  _this.selectedMonth = DateHelper.format(this.calendar.date ? new Date(this.calendar.date) : new Date(), 'MMMM YYYY');
                  _this.getWeekNumber();
                }
                renderData.eventColor = `${_this._utilityService.convertHexToRgba(_this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.primary_color) || '#887ECB', '0.3')}`;
                renderData.style = {
                  borderWidth: _this.metaData?.calendar.primary_color === 'none' ? '2.5px' : '',
                  borderColor: _this.metaData?.calendar.primary_color === 'none' ? 'rgba(210, 200, 200, 0.3)' : '',
                  borderLeftWidth: '5px',
                  borderLeftColor: eventBorderColor || '#e67e22',
                  backgroundColor: _this._utilityService.convertHexToRgba(_this._templateService.getCardColor(jobDetails, _this.metaData?.calendar.primary_color) || '#887ECB', '0.3')
                };
                return _this._templateService.getJobRendererTemplate('jobs', 'calendar', jobDetails?.job_uid, eventRecord['originalData'], 'day');
              } else if (eventType === 'nonJobEvent') {
                renderData.cls = {
                  ...renderData.cls,
                  'tentative-event': true,
                  'rounded-r-lg': true,
                  'border-gray-300': true,
                  'border-l-0': true,
                  'non-job-event': true
                };
                renderData.style = {
                  backgroundColor: 'rgba(245, 247, 249, 5)'
                };
                return _this._templateService.getNonJobEventRendererTemplate(jobDetails, 'DAY');
              }
            }
          },
          height: window.innerHeight - 180,
        },
        agenda: {
          eventRenderer(): any {
            if (_this.calendarMode === 'agenda') {
              _this.selectedDate = DateHelper.format(this.calendar.date ? new Date(this.calendar.date) : new Date(), 'MMM YYYY');
              _this.selectedMonth = DateHelper.format(this.calendar.date ? new Date(this.calendar.date) : new Date(), 'MMMM YYYY');
              _this.getWeekNumber();
            }
          }
        }
      },
      onDateChange: (event): any => {
        switch (_this.calendarMode) {
          case 'month':
          case 'agenda':
            _this.selectedDate = DateHelper.format(event.date, 'MMM YYYY');
            _this.selectedMonth = DateHelper.format(event.date, 'MMMM YYYY');
            _this.getWeekNumber();
            break;
          case 'week':
            const { start, end, startMonth, endMonth, startYear, endYear } = _this.getStartEndWeekAndMonth(event.date);
            if (startYear !== endYear) {
              _this.selectedDate = `${startMonth} ${start}, ${startYear} - ${endMonth} ${end}, ${endYear}`;
            } else {
              _this.selectedDate = `${startMonth} ${start} - ${endMonth} ${end}, ${endYear}`;
            }
            _this.selectedMonth = DateHelper.format(event.date, 'MMMM YYYY');
            _this.getWeekNumber();
            break;
          case 'day':
            _this.selectedDate = DateHelper.format(event.date, 'MMM DD, YYYY');
            _this.selectedMonth = DateHelper.format(event.date, 'MMMM YYYY');
            _this.getWeekNumber();
            break;
        }
      },
      onDayNumberClick: (event): any => {
        _this.changeCalendarMode('day');
      },
      onWeekNumberClick: (event): any => {
        _this.changeCalendarMode('week', event.date);
      },
      onScheduleDblClick: (event): any => {
        return false;
      },
    };
  }

  isDateInRange(start, end): boolean {
    const startDate = new Date(start.split('-').reverse().join('-'));
    const endDate = new Date(end.split('-').reverse().join('-'));
    endDate.setHours(23, 59, 59, 999);
    for (const item of this._dispatchBoardService.holidays) {
      const itemDate = new Date(item.date);
      if (itemDate >= startDate && itemDate <= endDate) {
        return true;
      }
    }
    return false;
  }

  closeCalendarEventDialog(): void {
    if (this.createdJobId) {
      this.calendar?.eventStore?.remove(this.createdJobId);
      this.createdJobId = null;
    }
    this.updateCalendarData();
    this.calendarHolidayDialogInstance?.close();
    this.setGridList();
  }

  setGridList(): any {
    this.grid.unscheduledJobs = [];
    this.grid.unscheduledJobcount = this.totalGridRecords;
    if (this.gridInstance) {
      this.gridInstance.data = this.grid.unscheduledJobs = this.gridData;
      this.gridInstance.refreshRows();
    }
  }

  getHolidays(): void {
    const params = {
      limit: 100
    };
    this._dataCollectorService.getData(this._dispatchBoardService.holidayUrl, params)
      .subscribe((response: any) => {
        response.data.forEach((holiday) => {
          holiday.date = moment(holiday.date).format('YYYY-MM-DD HH:mm');
          holiday.startDate = moment(holiday.date).format('YYYY-MM-DD HH:mm');
          holiday.endDate = moment(holiday.date).format('YYYY-MM-DD HH:mm');
          holiday.allDay = true;
          holiday.id = holiday.holiday_uid;
          holiday.resizable = false;
          holiday.draggable = false;
          holiday.allDayEventType = 'holiday';
          this.holidays.push(holiday);
        });
      });
    this._dispatchBoardService.holidays = this.holidays;
  }

  //#region calendar Filter
  openJobCalendarFilter(moduleName: any): void {
    this._analytics.trackEvent('web_calendar_advanced_filter_button_clicked');
    this.ngxTippyService.hide('tippycalendarSearch');
    this.calendarFilterDrawerData.openFilter = true;
    this.calendarFilterDrawerData.addNewFilter = false;
    this.calendarFilterDrawerData.saveFilterByDefault = false;
    const jobCalendarFilter = this._localStorageService.getLocalStorage('job_calendar_filter');
    if (jobCalendarFilter) {
      this.calendarFilterDrawerData.jobCalendarFilterValues = jobCalendarFilter;
    } else {
      this.calendarFilterDrawerData.jobCalendarFilterValues = this.getFilterValues();
    }
  }

  updateFiltersInPopup(): void {
    const jobCalendarFilter = this._localStorageService.getLocalStorage('job_calendar_filter');
    if (jobCalendarFilter) {
      this.calendarFilterDrawerData.jobCalendarFilterValues = jobCalendarFilter;
    } else {
      this.calendarFilterDrawerData.jobCalendarFilterValues = this.getFilterValues();
    }
  }

  getFilterValues(): any {
    const filterValue = this.filterForm.value;
    const filteredEmployeesArray = filterValue?.employees;
    const selectedEmployeesItems = [];
    filteredEmployeesArray?.forEach((user: any) => {
      selectedEmployeesItems.push(user.user_uid);
    });
    const filteredTeamsArray = filterValue?.teams;
    const selectedTeamsItems = [];
    filteredTeamsArray?.forEach((team: any) => {
      selectedTeamsItems.push(team.team_uid);
    });
    const jobFilterValue: any = {
      'filter.keyword': this.calendarParams['filter.keyword'] ?? '',
      'filter.job_category': filterValue.jobCategory?.toString() ?? '',
      'filter.job_status': filterValue.jobStatus?.toString() ?? '',
      'filter.due_date_from': '',
      'filter.due_date_to': '',
      'filter.from_date': '',
      'filter.to_date': '',
      'filter.skillset_uid': filterValue.skills?.toString() ?? '',
      'filter.service_territory': filterValue.territory?.toString() ?? '',
      'filter.priority': '',
      'filter.job_tags': filterValue.tags?.toString() ?? '',
      'filter.assigned': filterValue.assigned?.toString() ?? '',
      'due_date_type': filterValue.dueDateType ?? 'ANY',
      'filter.customer': filterValue.customer?.toString() ?? '',
      'filter.customer_organization': filterValue.organization?.toString() ?? '',
      'filter.property': filterValue.property?.toString() ?? '',
      'filter.assigned_to_team': selectedTeamsItems ? selectedTeamsItems.join(',') : '',
      'filter.assigned_to': selectedEmployeesItems ? selectedEmployeesItems.join(',') : '',
      'filter.project': filterValue.project?.toString() ?? '',
    };

    if (filterValue?.dueDateFrom?.format) {
      jobFilterValue['filter.due_date_from'] = filterValue?.dueDateFrom?.format('YYYY-MM-DD');
    }
    if (filterValue?.dueDateTo?.format) {
      jobFilterValue['filter.due_date_to'] = filterValue?.dueDateTo?.format('YYYY-MM-DD');
    }
    if (filterValue.priority && filterValue.priority !== 'ALL') {
      jobFilterValue['filter.priority'] = filterValue.priority;
    }
    return jobFilterValue;
  }

  filterDrawerEmitter(event: any): void {
    this.calendarFilterDrawerData.openFilter = false;
    if (event?.filter_uid) {
      this.selectedQuickFilter = event.filter_uid;
      this.getQuickFilters(true, this.selectedQuickFilter);
      this._localStorageService.removeLocalStorage('job_calendar_filter');
      this._localStorageService.setLocalStorage('quick_filter_uid', this.selectedQuickFilter);
    } else {
      if (event?.isClosed) {
        this._localStorageService.removeLocalStorage('quick_filter_uid');
      }
    }
    if (event?.isClosed) {
      if (!event?.filter_uid) {
        this.selectedQuickFilter = 'ALL';
      }
      if (event?.type === 'apply') {
        this._analytics.trackEvent('web_calendar_advanced_filter_apply_button_clicked');
        this.teamOptions = [];
        this.employeeOptions = [];
      }
      this.assignFilteredData(event.filter, true);
    } else {
      this._analytics.trackEvent('web_calendar_advanced_filter_cancel_button_clicked');
    }
    if (event?.type === 'reset') {
      this.selectedQuickFilter = 'ALL';
      this.calendarSearchKeyword = '';
      this.calendarParams['filter.keyword'] = '';
    }
  }

  assignFilteredData(filter, isFromQickFilter?: boolean): any {
    this.advancedFilterCount = Object.keys(filter)
      .filter(key => filter[key] && filter[key] !== 'ANY' && key !== 'filter.job_category' && key !== 'filter.job_status' && key !== 'filter.assigned_to_team' && key !== 'filter.assigned_to' && key !== 'from_date' && key !== 'to_date')
      .length;
    this.filterSubscription?.unsubscribe();
    this.calendarFilterDrawerData.openFilter = false;
    this.selectedJobCategoryItems = filter ? filter['filter.job_category'] ? filter['filter.job_category']?.split(',').map(id => id.trim()) : [] : [];
    this.filteredJobCategoryArray = this.jobsCategory.filter(obj => this.selectedJobCategoryItems?.includes(obj.category_uid));
    this.filterForm.get('jobCategory').setValue(this.selectedJobCategoryItems);
    const selectedCategories: any[] = this.filterForm.get('jobCategory')?.value ?? [];
    this.jobsStatuses = selectedCategories.length > 0 ? this.getSelectedCategoriesStatus(selectedCategories) : [];
    this.selectedStatusItems = filter ? filter['filter.job_status'] ? filter['filter.job_status']?.split(',').map(id => id.trim()) : [] : [];
    this.filteredStatusArray = this.jobsStatuses.filter(obj => this.selectedStatusItems?.includes(obj.status_uid));
    this.filterForm.get('jobStatus').setValue(this.selectedStatusItems);
    if (this.selectedJobCategoryItems.length > 0 && this.jobsStatuses.length !== 0 && (this.jobsStatuses.length === this.filteredStatusArray.length)) {
      this.isAnyStatus = true;
    } else {
      this.isAnyStatus = false;
    }
    this.selectedTeamsItems = filter ? filter['filter.assigned_to_team'] ? filter['filter.assigned_to_team']?.split(',').map(id => id.trim()) : [] : [];
    // this.filteredTeamsArray = this.teamOptions.filter(obj => this.selectedTeamsItems?.includes(obj.team_uid));
    // this.filterForm.get('teams').setValue(this.filteredTeamsArray);
    this.selectedEmployeesItems = filter ? filter['filter.assigned_to'] ? filter['filter.assigned_to']?.split(',').map(id => id.trim()) : [] : [];
    // this.filteredEmployeesArray = this.employeeOptions.filter(obj => this.selectedEmployeesItems?.includes(obj.user_uid));
    // this.filterForm.get('employees').setValue(this.filteredEmployeesArray);
    const { startDate, endDate } = this.getStartAndEndDate(this.calendar.date);
    filter['from_date'] = startDate;
    filter['to_date'] = endDate;
    this.calendarSearchKeyword = filter ? filter['filter.keyword'] : '';
    if (this.calendarSearchKeyword) {
      filter['filter.keyword'] = this.calendarSearchKeyword;
      const searchKeyword = this.calendarSearchKeyword?.trim();
      this.calendarParams['filter.keyword'] = searchKeyword;
    }
    this.getFilteredJobs(filter);
    this.getEventCount(this.calendar.date, filter);
    if (this.selectedEmployeesItems.length > 0) {
      this.getAllEmployees(isFromQickFilter);
    } else {
      this.filteredEmployeesArray = this.employeeOptions.filter(obj => this.selectedEmployeesItems?.includes(obj.user_uid));
      this.filteredEmployeesArray = this.filteredEmployeesArray.filter((value, index, self) =>
        self.findIndex(v => v.user_uid === value.user_uid) === index);
      this.filterForm.get('employees').setValue(this.filteredEmployeesArray);
    }
    if (this.selectedTeamsItems.length > 0) {
      this.getAllTeams(isFromQickFilter);
    } else {
      this.filteredTeamsArray = this.teamOptions.filter(obj => this.selectedTeamsItems?.includes(obj.team_uid));
      this.filteredTeamsArray = this.filteredTeamsArray.filter((value, index, self) =>
        self.findIndex(v => v.team_uid === value.team_uid) === index);
      this.filterForm.get('teams').setValue(this.filteredTeamsArray);
    }
  }

  getFilteredJobs(filter): void {
    filter['view'] = this.calendarMode.toUpperCase();
    this.loaded = false;
    this.getNonJobEventData();
    if (this.metaData?.calendar?.display?.show_timeoff) {
      this.gettimeOffList(this.getFirstFilterParams()['from_date'], this.getFirstFilterParams()['to_date']);
    }
    this._dataCollectorService.getData(this._dispatchBoardService.jobCalendarDataUrl, filter).subscribe((res: any): void => {
      this.jobsArrBackup = res.data;
      if (this.calendarMode !== 'month') {
        this.jobsArr = this.events = this.splitJobs(res.data);
        this.calendar.eventStore.loadDataAsync(this.events);
      } else {
        res.data?.forEach((job, index) => {
          job.id = job.job_uid;
          if (job.scheduled_start_time && job.scheduled_end_time) {
            job.startDate = moment.tz(job.scheduled_start_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
            job.endDate = moment.tz(job.scheduled_end_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
          }
          job.eventColor = '#3c763d';
          job.eventType = 'JOB';
          if (job.current_job_status && job.current_job_status.status_type === 'CLOSED') {
            job.resizable = false;
            job.draggable = false;
          }
        });
        this.jobsArr = this.events = res.data;
      }
      this.events.push(...this.holidays);
      if (this.metaData?.calendar?.display?.show_timeoff) {
        this.events.push(...this.timeOffList);
      }
      this.events.push(...this.calendarNonJobEvents);
      this.updateCalendarStore();
      // this.events = this.jobsArr;
      this._dispatchBoardService.setCalendarRecords(this.jobsArr);

      this.loaded = true;
    });
  }

  updateCalendarStore(): any {
    setTimeout(() => {
      this.calendar.eventStore.loadDataAsync(this.events);
    }, 500);
  }

  previewDataEventHandler(event: any): void {
    if (event.drawerClosed) {
      this.openDrawer = false;
      this.getAllJobs(this.calendar.date);
      this.getEventCount(this.calendar.date);
    }
    if (event.action === 'DELETE' && event.uid) {
      this._analytics.trackEvent('web_calendar_delete_job_clicked');
      this.calendar?.eventStore?.remove(event.uid);
    }
    else if (event.action === 'CLONE' && event.uid) {
      this._analytics.trackEvent('web_calendar_clone_job_clicked');
      this.cloneJob(event.job);
    }
  }

  cloneJob(jobDetails): void {
    const jobUid = jobDetails?.job_uid;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const job: dataObj = { job_uid: this.getOriginalJobUid(jobUid), action: 'clone', isDialog: true };
    // if (disableRecurrence) {
    job['disableRecurrence'] = true;
    // }
    const advancedJobService = this._zuperDialogService.openCustom(JobFormComponent, {
      data: job,
      extraClass: 'advanced-job-dialog'
    });
    advancedJobService.afterClosed()
      .subscribe((dialogData: any) => {
        if (dialogData?.job_uid) {
          this.getAllJobs(this.calendar.date);
          this.getEventCount(this.calendar.date);
        }
      });
  }

  getPreviewDataOptions(): void {
    this.previewDataOptions = {
      position: 'right',
      type: 'summary',
      mode: 'over',
      hasBackDrop: false,
      allowToEdit: this.permissions.updateJob,
      menuOptions: {
        viewDetails: true,
        clone: true,
        delete: true
      },
    };
  }

  getModuleID(): string {
    return this.jobUid;
  }

  getStartEndWeekAndMonth(inputDate: Date): any {
    const date = moment(inputDate);
    const weekStartDay = this.metaData?.calendar?.display.weekStartDay ?? 1;
    const day = date.day();
    const startDate = moment(date).startOf('day').subtract((day - weekStartDay + 7) % 7, 'days');
    const endDate = moment(startDate).add(6, 'days'); // Adjusting the end date using moment
    // Format the dates as strings
    const startDateStr = startDate.format('DD');
    const endDateStr = endDate.format('DD');

    // Format the months as three-letter strings
    const startMonth = startDate.format('MMM');
    const endMonth = endDate.format('MMM');

    const startYear = startDate.format('YYYY');
    const endYear = endDate.format('YYYY');

    return {
      start: startDateStr,
      end: endDateStr,
      startMonth,
      endMonth,
      startYear,
      endYear
    };
  }

  getDateRange(inputDate: Date): any {
    const date = moment(inputDate);
    const day = date.day();
    const startDate = moment(date);


    // Calculate the start of the week based on the specified type
    startDate.date(date.date() - day + this.metaData?.calendar?.display.weekStartDay);
    const endDate = moment(startDate).add(6, 'days'); // Adjusting the end date using moment
    // Format the dates as strings
    const startDateStr = startDate.format('DD-MM-YYYY');
    const endDateStr = endDate.format('DD-MM-YYYY');

    return {
      startDate: startDateStr,
      endDate: endDateStr,
    };
  }

  changeCalendarMode(mode: string, date?: any): void {
    if(this.disableModeTab) {return;}
    this.disableModeTab = true;
    switch (mode) {
      case 'month':
        this._analytics.trackEvent('web_calendar_month_view_button_clicked');
        break;
      case 'week':
        this._analytics.trackEvent('web_calendar_week_view_button_clicked');
        break;
      case 'day':
        this._analytics.trackEvent('web_calendar_day_view_button_clicked');
        break;
    }
    this.events = [];
    this.calendar.eventStore.loadDataAsync(this.events);
    this.autoRowHeight = mode !== 'month';
    this.calendarMode = mode;
    this.calendar.mode = mode;
    this.updateDateDesc();
    this.filterSubscription?.unsubscribe();
    this.activeDate = date ? date : this.calendar.date;
    this.getEventCount(date ? date : this.calendar.date);
    this.getAllJobs(date ? date : this.calendar.date);
  }

  updateDateDesc(): any {
    let dayViewHeader: any;
    switch (this.calendarMode) {
      case 'month':
      case 'agenda':
        this.selectedDate = DateHelper.format(this.calendar ? new Date(this.calendar.date) : new Date(), 'MMM YYYY');
        this.selectedMonth = DateHelper.format(this.calendar ? new Date(this.calendar.date) : new Date(), 'MMMM YYYY');
        break;
      case 'week':
        const { start, end, startMonth, endMonth, startYear, endYear } = this.getStartEndWeekAndMonth(this.calendar ? new Date(this.calendar.date) : new Date());
        if (startYear !== endYear) {
          this.selectedDate = `${startMonth} ${start}, ${startYear} - ${endMonth} ${end}, ${endYear}`;
        } else {
          this.selectedDate = `${startMonth} ${start} - ${endMonth} ${end}, ${endYear}`;
        }
        this.selectedMonth = DateHelper.format(this.calendar ? new Date(this.calendar.date) : new Date(), 'MMMM YYYY');
        this.getWeekNumber();
        break;
      case 'day':
        this.selectedDate = DateHelper.format(this.calendar ? new Date(this.calendar.date) : new Date(), 'MMM DD, YYYY');
        this.selectedMonth = DateHelper.format(this.calendar ? new Date(this.calendar.date) : new Date(), 'MMMM YYYY');
        this.getWeekNumber();
        break;
    }
  }

  getWeekNumber(): any {
    const activeWeekElement = document.querySelector('.b-minical-active-week');
    const parentRow = activeWeekElement ? activeWeekElement.closest('[role="row"]') : null;
    const weekNumberCell = parentRow ? parentRow.querySelector('.b-week-number-cell') : null;
    if (weekNumberCell) {
      this.weekNumber = +weekNumberCell.innerHTML;
    }
  }


  goTocalendar(action: string): void {
    if (action === 'next') {
      this.calendar.shiftNext();
    } else if (action === 'prev') {
      this.calendar.shiftPrevious();
    } else {
      this.calendar.shiftToNow();
      this.startDate = this.calendar.date;
    }
    this.activeDate = this.calendar.date;
    this.getEventCount(this.calendar.date);
    this.getAllJobs(this.calendar.date);
  }

  openSettingsDialog(moduleName: string): void {
    this._analytics.trackEvent('web_calendar_settings_icon_clicked');
    this.settingsDialogdata = {};
    this.settingsDialogdata['module'] = moduleName;
    this._sharedService.settingsDialogInstance = this._zuperDialogService.openCustom(CalendarSettingsComponent, {
      data: this.settingsDialogdata,
      selectedType: '',
      extraClass: 'w-fit'
    });
    this._sharedService.settingsDialogInstance.afterClosed()
      .subscribe((dialogData: any) => {
        if (dialogData) {
          this.metaData = dialogData;
          this.metaData = this._calendarService.sanitizeTemplateMetaData(this.metaData);
          this.calendarConfig.modes = {
            day: {
              hourHeight: this.metaData?.calendar?.display?.business_hours_only ? 100 + (this.sliderHeightValue || 0) : (this.sliderHeightValue * 1.09) + 31,
              minDayWidth: this.sliderWidthValue ? (this.sliderWidthValue * 50) : 0,
              dayStartTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().start_time : '00:00:01',
              dayEndTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().end_time : '24:00:00',
              visibleStartTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().start_time : '00:00:01',
              hideNonWorkingDays: this.metaData?.calendar?.display?.weekends ? false : true,
              weekStartDay: this.metaData?.calendar?.display.weekStartDay
            },
            week: {
              hourHeight: this.metaData?.calendar?.display?.business_hours_only ? 100 + (this.sliderHeightValue || 0) : (this.sliderHeightValue * 1.09) + 30,
              minDayWidth: this.sliderWidthValue ? (this.sliderWidthValue * 50) : 0,
              dayStartTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().start_time : '00:00:01',
              dayEndTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().end_time : '24:00:00',
              visibleStartTime: this.metaData?.calendar?.display?.business_hours_only ? this.getBusinessHours().start_time : '00:00:01',
              hideNonWorkingDays: this.metaData?.calendar?.display?.weekends ? false : true,
              weekStartDay: this.metaData?.calendar?.display.weekStartDay
            },
            month: {
              weekStartDay: this.metaData?.calendar?.display.weekStartDay,
              hideNonWorkingDays: this.metaData?.calendar?.display?.weekends ? false : true,
            }
          };
          if (!this.metaData?.calendar?.display?.show_timeoff) {
            this.timeOffList = [];
          }
          this.pickerConfig.hideNonWorkingDays = this.metaData?.calendar?.display?.weekends ? false : true;
          this.pickerConfig.showWeekNumber = this.metaData?.calendar?.display?.week_numbers;
          this.calendarConfig.modes.month['showWeekNumber'] = this.metaData?.calendar?.display?.week_numbers;
          this.autoRowHeight = this.calendar.mode !== 'month';
          this.getEventCount(this.calendar.date);
          this.getAllJobs(this.calendar.date);
        }
      });
  }

  setDefaultMetaData(): void {
    let settingsData: any;
    const localMetadata = this._localStorageService.getLocalStorage('calendar_metadata');
    if (!this._utilityService.isEmptyOrUndefined(localMetadata)) {
      if (!localMetadata?.calendar) {
        localMetadata['calendar'] = this._sharedService.calendarForm.value;
      }
      localMetadata['calendar'] = _.defaultsDeep(localMetadata['calendar'], this._sharedService.calendarForm.value);
      settingsData = localMetadata;
    }
    else {
      const calendarData = this._sharedService.calendarForm.value || {};
      settingsData = { 'calendar': calendarData };
      this._localStorageService.setLocalStorage('calendar_metadata', settingsData);
    }
    return settingsData;
  }

  getWorkStartTime(date, businessHours): any {
    const startOfDay = moment(date).startOf('day');
    const workStartTime = businessHours ? moment(businessHours.start_time, 'HH:mm:ss') : startOfDay;

    // If job start time is before work hours, use work hours start time
    if (date.getHours() === 0 || date.isBefore(workStartTime)) {
      return moment(date).set({
        'hour': workStartTime.hours(),
        'minute': workStartTime.minutes(),
        'second': workStartTime.seconds(),
      });
    }

    return moment(date);
  }

  getWorkEndTime(date, businessHours): any {
    const endOfDay = moment(date).endOf('day');
    const workEndTime = businessHours ? moment(businessHours.end_time, 'HH:mm:ss') : endOfDay;

    // If job end time is after work hours, use work hours end time
    if (date.getHours() === 0 || date.isAfter(workEndTime)) {
      return moment(date).set({
        'hour': workEndTime.hours(),
        'minute': workEndTime.minutes(),
        'second': workEndTime.seconds(),
      });
    }

    return moment(date);
  }

  compareTime(date, time): any {
    const dateHours = date.getHours();
    const dateMinutes = date.getMinutes();
    const { hours, minutes } = time;

    if (dateHours !== hours) {
      return dateHours - hours;
    }

    return dateMinutes - minutes;
  }


  //#region Assign Employees Fetching Related Methods
  getAllEmployees(intiated?: boolean): void {
    if (intiated) {
      this.employeeParamObj['filter.user_uid'] = this.selectedEmployeesItems ? this.selectedEmployeesItems.join(',') : '';
    } else {
      this.employeeParamObj['filter.user_uid'] = '';
    }
    const urlParams = this._utilityService.constructParam(this.employeeParamObj);
    this.employeeFetching = true;
    this._dataCollectorService.getData(this._calendarService.employeeUrl, urlParams).subscribe((response: any) => {
      this.employeeOptions = this.employeeOptions.concat(response.data);
      this.employeeOptions = this.employeeOptions.filter((value, index, self) =>
        self.findIndex(v => v.user_uid === value.user_uid) === index);
      delete this.employeeParamObj['filter.user_uid'];
      this.employeePagination.loadingIndex = response.current_page;
      this.employeePagination.totalPage = response.total_pages;
      this.employees = this.filterForm.get('employees').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.employeeOptions)
      );
      this.filteredEmployeesArray = this.employeeOptions.filter(obj => this.selectedEmployeesItems?.includes(obj.user_uid));
      this.filteredEmployeesArray = this.filteredEmployeesArray.filter((value, index, self) =>
        self.findIndex(v => v.user_uid === value.user_uid) === index);
      this.filterForm.get('employees').setValue(this.filteredEmployeesArray);
      this.employeeFetching = false;
    }, (error: any) => {
      this.employeeFetching = false;
    });
  }

  onEmployeeSearch(): void {
    this.employees = this.employeeValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getEmployees(term))
    );
  }

  onEmployeeClear(): void {
    this.employees = this.getEmployees('');
  }

  onEmployeeScrollToEnd(): void {
    if (this.employeePagination.loadingIndex < this.employeePagination.totalPage) {
      this.employeePagination.loadingIndex++;
      this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
      this.employeeParamObj['page'] = this.employeePagination.loadingIndex;
      this.employeeFetching = true;
      const urlParams = this._utilityService.constructParam(this.employeeParamObj);
      this._dataCollectorService.getData(this._calendarService.employeeUrl, urlParams).subscribe(
        (response: any) => {
          this.employeeFetching = false;
          this.employeeOptions = this.employeeOptions.concat(response.data);
          this.employeeOptions = this.employeeOptions.filter((value, index, self) =>
            self.findIndex(v => v.user_uid === value.user_uid) === index);
          this.employees = this.filterForm.get('employees').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.employeeOptions)
          );
          this.filteredEmployeesArray = this.employeeOptions.filter(obj => this.selectedEmployeesItems?.includes(obj.user_uid));
          this.filteredEmployeesArray = this.filteredEmployeesArray.filter((value, index, self) =>
            self.findIndex(v => v.user_uid === value.user_uid) === index);
          this.filterForm.get('employees').setValue(this.filteredEmployeesArray);
        }, (error: any) => {
          this.employeeFetching = false;
        });
    }
  }

  getEmployees(input: string): Observable<any[]> {
    this.employeePagination.keyword = input ? input : '';
    this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
    this.employeeParamObj['page'] = 1;
    const urlParams = this._utilityService.constructParam(this.employeeParamObj);
    this.employeeFetching = true;
    return this._dataCollectorService.getData(this._calendarService.employeeUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.employeePagination.loadingIndex = response.current_page;
          this.employeePagination.totalPage = response.total_pages;
          this.employeeOptions = response.data;
          this.employeeFetching = false;
          return response.data;
        }),
      );
  }

  isEmployeeAssigned(item: any): boolean {
    if (this.filterForm.value?.employees?.length) {
      const selectedUser: any = this.filterForm.value?.employees?.find(value => item?.user_uid === value?.user_uid);
      return selectedUser ? true : false;
    }
    return false;
  }

  //#region Assign Teams Fetching Related Methods
  getAllTeams(intiated?: boolean): void {
    if (intiated) {
      this.teamParamObj['filter.team_uid'] = this.selectedTeamsItems ? this.selectedTeamsItems.join(',') : '';
    } else {
      this.teamParamObj['filter.team_uid'] = '';
    }
    const urlParams = this._utilityService.constructParam(this.teamParamObj);
    this.teamFetching = true;
    this._dataCollectorService.getData(this._calendarService.teamUrl, urlParams).subscribe((response: any) => {
      delete this.teamParamObj['filter.team_uid'];
      this.teamOptions = this.teamOptions.concat(response.data);
      this.teamOptions = this.teamOptions.filter((value, index, self) =>
        self.findIndex(v => v.team_uid === value.team_uid) === index);
      this.teamPagination.loadingIndex = response.current_page;
      this.teamPagination.totalPage = response.total_pages;
      this.teams = this.filterForm.get('teams').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.teamOptions)
      );
      this.teamFetching = false;
      this.filteredTeamsArray = this.teamOptions.filter(obj => this.selectedTeamsItems?.includes(obj.team_uid));
      this.filteredTeamsArray = this.filteredTeamsArray.filter((value, index, self) =>
        self.findIndex(v => v.team_uid === value.team_uid) === index);
      this.filterForm.get('teams').setValue(this.filteredTeamsArray);
    }, (error: any) => {
      this.teamFetching = false;
    });
  }

  onTeamSearch(): void {
    this.teams = this.teamValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getTeams(term))
    );
  }

  onTeamClear(): void {
    this.teams = this.getTeams('');
  }

  onTeamScrollToEnd(): void {
    if (this.teamPagination.loadingIndex < this.teamPagination.totalPage) {
      this.teamPagination.loadingIndex++;
      this.teamParamObj['filter.keyword'] = this.teamPagination.keyword;
      this.teamParamObj['page'] = this.teamPagination.loadingIndex;
      this.teamFetching = true;
      const urlParams = this._utilityService.constructParam(this.teamParamObj);
      this._dataCollectorService.getData(this._calendarService.teamUrl, urlParams).subscribe(
        (response: any) => {
          this.teamFetching = false;
          this.teamOptions = this.teamOptions.concat(response.data);
          this.teamOptions = this.teamOptions.filter((value, index, self) =>
            self.findIndex(v => v.team_uid === value.team_uid) === index);
          this.teams = this.filterForm.get('teams')?.valueChanges.pipe(
            startWith(''),
            map((value: any) => this.teamOptions)
          );
          this.filteredTeamsArray = this.teamOptions.filter(obj => this.selectedTeamsItems?.includes(obj.team_uid));
          this.filteredTeamsArray = this.filteredTeamsArray.filter((value, index, self) =>
            self.findIndex(v => v.team_uid === value.team_uid) === index);
          this.filterForm.get('teams').setValue(this.filteredTeamsArray);
        }, (error: any) => {
          this.teamFetching = false;
        });
    }
  }

  getTeams(input: string): Observable<any[]> {
    this.teamPagination.keyword = input ? input : '';
    this.teamParamObj['filter.keyword'] = this.teamPagination.keyword;
    this.teamParamObj['page'] = 1;
    const urlParams = this._utilityService.constructParam(this.teamParamObj);
    this.teamFetching = true;
    return this._dataCollectorService.getData(this._calendarService.teamUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.teamPagination.loadingIndex = response.current_page;
          this.teamPagination.totalPage = response.total_pages;
          this.teamOptions = response.data;
          this.teamFetching = false;
          return response.data;
        }),
      );
  }

  isTeamAssigned(item: any): boolean {
    if (this.filterForm.value?.teams?.length) {
      const selectedTeam: any = this.filterForm.value?.teams?.find(value => item?.team_uid === value?.team_uid);
      return selectedTeam ? true : false;
    }
    return false;
  }

  getMetaData(): void {
    const params = {
      module: 'SCHEDULE',
      key: 'CALENDAR'
    };
    this._dataCollectorService.getData(this._calendarService.metaDataUrl, params)
      .subscribe((response: any) => {
        this.settingsDialogdata = {};
        this.metaData = response['data']?.[0]['value'] ? JSON.parse(response['data']?.[0]['value']) : {};
        this.metaData = this._calendarService.sanitizeTemplateMetaData(this.metaData);
        if (!this.metaData?.grid) {
          if (this._utilityService.isEmptyOrUndefined( this.metaData)) {
            this.metaData = this.setDefaultMetaData();
            this.metaData = this._calendarService.sanitizeTemplateMetaData(this.metaData);
          }
          this._localStorageService.setLocalStorage('calendar_metadata', this.metaData);
          this.settingsDialogdata['newToCalendar'] = true;
          this.calendarMode = this.metaData?.calendar?.display?.defaultCalendarView || 'week';
          this.calendar.mode = this.calendarMode;
          this.updateDateDesc();
          this.calendarConfig?.modes?.month && this.calendarConfig?.modes?.month['showWeekColumn'] ? this.calendarConfig.modes.month['showWeekColumn'] = this.metaData?.calendar?.display?.week_numbers : false;
          if (this.calendarMode === 'month') {
            this.selectedDate = DateHelper.format(new Date(), 'MMM YYYY');
            this.selectedMonth = DateHelper.format(new Date(), 'MMMM YYYY');
            setTimeout(() => {
              this.getWeekNumber();
            }, 25);
          };
          this.autoRowHeight = this.calendar.mode !== 'month';

          this.selectedQuickFilter = this._localStorageService.getLocalStorage('quick_filter_uid');
          this.route.queryParams.subscribe(params => {
            if (params.type === 'NON_JOB_EVENT') {
              this.nonJobEventPreview(params.action_uid);
            } else{
              this.getQuickFilters(true, this.selectedQuickFilter);
            }
          });
        }
      });
  }

  getFirstAllJobs(): any {
    this.loaded = false;
    const observables: any = {
      nonJobEventData: this.getNonJobEventDataObservable()
    };
    if (this.metaData?.calendar?.display?.show_timeoff) {
      observables.timeOffList = this.gettimeOffListObservable(this.getFirstFilterParams()['from_date'], this.getFirstFilterParams()['to_date']);
    }
    this.unsubscribeAll();
    this.forkJoinSubscription = forkJoin(observables).subscribe({
      next: () => {
        this.filteredSubscription = this._dataCollectorService.getData(this._dispatchBoardService.jobCalendarDataUrl, this.getFirstFilterParams())
          .subscribe({
            next: (res: any): void => {
              this.loaded = true;
              this.jobsArrBackup = res.data;
              if (this.calendarMode !== 'month') {
                this.jobsArr = this.events = this.splitJobs(res.data);
                this.calendar.eventStore.loadDataAsync(this.events);
              } else {
                res.data?.forEach((job, index) => {
                  job.id = job.job_uid;
                  if (job.scheduled_start_time && job.scheduled_end_time) {
                    job.startDate = moment.tz(job.scheduled_start_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
                    job.endDate = moment.tz(job.scheduled_end_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
                  }
                  job.eventColor = '#3c763d';
                  job.eventType = 'JOB';
                  if (job.current_job_status && job.current_job_status.status_type === 'CLOSED') {
                    job.resizable = false;
                    job.draggable = false;
                  }
                });
                this.jobsArr = this.events = res.data;
              }
              this.events.push(...this.holidays);
              if (this.metaData?.calendar?.display?.show_timeoff) {
                this.events.push(...this.timeOffList);
              }
              this.events.push(...this.calendarNonJobEvents);
              this.updateCalendarStore();
              setTimeout(() => {
                if (this.calendarMode !== 'month') {
                  const activeDateElement = document.querySelector('.b-today') as HTMLElement;
                  if (activeDateElement) {
                    const parentElement = activeDateElement.parentNode as Element;
                    if (parentElement) {
                      parentElement.classList.add('b-minical-active-week');
                    }
                  }
                }
              }, 15);
              this._dispatchBoardService.setCalendarRecords(this.jobsArr);
            },
            error: (error) => {
              this.loaded = true;
            }
          });
      },
      error: (err) => {
        this.loaded = true;
      }
    });
  }

  getEventCount(date?: any, params?: any): void {
    this.showCalendarPicker = false;
    const { startDate, endDate } = this.getEventCountStartAndEndDate(date);
    const filterParams = params ?? this.getFilterParams();
    const eventParams: any = {
      module_name: 'JOB',
      from_date: startDate,
      to_date: endDate,
    };
    for (const [key, value] of Object.entries(filterParams)) {
      if (!['view', 'from_date', 'to_date'].includes(key)) {
        eventParams[`job_${key}`] = value;
      }
    }
    this.eventCountSubscription = this._dataCollectorService.getEventCount(this._calendarService.eventsCountUrl, eventParams)
      .subscribe((response: any) => {
        this.pickerConfig.weekStartDay = this.metaData?.calendar?.display?.weekStartDay;
        this.eventCountArr = response['data'];
        this.eventCountMap = new Map();
        this.eventCountArr.forEach((item: any) => {
          const itemDate = moment(item['date']);
          const key = `${itemDate.year()}-${itemDate.month() + 1}-${itemDate.date()}`;
          this.eventCountMap.set(key, item['total']);
        });
        this.pickerConfig.showWeekNumber = this.metaData?.calendar?.display?.week_numbers;
        this.pickerConfig.hideNonWorkingDays = this.metaData?.calendar?.display?.weekends ? false : true;
        this.activeDate = this.calendar.date;
        this.showCalendarPicker = true;
        this.updateMiniCalendarCss();
        setTimeout(() => {
          this.getWeekNumber();
        }, 25);
      },
      (error: any) => {
        this.eventCountArr = null;
        this.pickerConfig.showWeekNumber = this.metaData?.calendar?.display?.week_numbers;
        this.pickerConfig.hideNonWorkingDays = this.metaData?.calendar?.display?.weekends ? false : true;
        this.showCalendarPicker = true;
      });
  }

  toggleSidePanel(): any {
    this._analytics.trackEvent('web_calendar_side_collapse_button_clicked');
    this.showSidePanel = !this.showSidePanel;
    this.updateMiniCalendarCss();
  }

  updateMiniCalendarCss(): void {
    setTimeout(() => {
      if (this.calendarMode === 'week') {
        const new_date = moment(this.activeDate).format('YYYY-MM-DD');
        const calendarWeekdays1 = document.querySelector('.b-minical-active-week') as HTMLElement;
        if (calendarWeekdays1) {
          calendarWeekdays1.classList.remove('b-minical-active-week');
        }
        const new_date_ele = document.querySelector(`[data-date="${new_date}"]`) as HTMLElement;
        const parentElement = new_date_ele.parentNode as Element;
        if (parentElement) {
          parentElement.classList.add('b-minical-active-week');
        }
      }
    }, 0);
    setTimeout(() => {
      const calendarWeekdays = document.querySelector('.b-calendar-weekdays') as HTMLElement;
      if (calendarWeekdays) {
        const weekNumberCell = calendarWeekdays.querySelector('.b-week-number-cell') as HTMLElement;
        if (weekNumberCell) {
          weekNumberCell.style.backgroundColor = 'white'; // Replace 'your-desired-color' with the actual color you want
        }
      }
      const elementWithRowIndex0 = document.querySelector('[data-row-index="0"]') as HTMLElement;
      const weekNumberCell0 = elementWithRowIndex0?.querySelector('.b-week-number-cell') as HTMLElement;
      weekNumberCell0?.classList.add('b-calendar-index-0');
      const elementWithRowIndex5 = document.querySelector('[data-row-index="5"]') as HTMLElement;
      const weekNumberCell1 = elementWithRowIndex5?.querySelector('.b-week-number-cell') as HTMLElement;
      weekNumberCell1?.classList.add('b-calendar-index-5');
    }, 10);
  }

  getEventCountStartAndEndDate(date?: any): any {
    const inputDate = date || new Date();
    const year = inputDate.getFullYear();
    const month = inputDate.getMonth();
    // Get the total number of days in the month
    const totalDaysInMonth = new Date(year, month + 1, 0).getDate();
    // Calculate the middle date of the month
    const middleDay = Math.ceil(totalDaysInMonth / 2);
    const middleDateObject = new Date(year, month, middleDay);
    // Calculate the start date (30 days before the middle date)
    const startDateObject = new Date(middleDateObject);
    startDateObject.setDate(startDateObject.getDate() - 30);
    // Calculate the end date (30 days after the middle date)
    const endDateObject = new Date(middleDateObject);
    endDateObject.setDate(endDateObject.getDate() + 30);
    const formatDateString = (dateObject) => {
      const y = dateObject.getFullYear();
      const m = (dateObject.getMonth() + 1).toString().padStart(2, '0');
      const d = dateObject.getDate().toString().padStart(2, '0');
      return `${y}-${m}-${d}`;
    };
    const startDate = formatDateString(startDateObject);
    const endDate = formatDateString(endDateObject);
    return { startDate, endDate };
  }

  getStartAndEndDate(date: any): any {
    const inputDate = date || new Date();
    let startDate, endDate;

    const formatDate = (d: Date): string => {
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    if (this.calendarMode === 'day') {
      startDate = formatDate(inputDate);
      endDate = startDate;
    } else if (this.calendarMode === 'week') {
      const weekStartDay = this.metaData?.calendar?.display.weekStartDay || 1;
      const currentDay = inputDate.getDay();

      // Calculate the start of the week based on the specified weekStartDay
      const startOfWeek = new Date(inputDate);
      startOfWeek.setDate(inputDate.getDate() - (currentDay - weekStartDay + 7) % 7);
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      startDate = formatDate(startOfWeek);
      endDate = formatDate(endOfWeek);

    } else if (this.calendarMode === 'month') {
      const year = inputDate.getFullYear();
      const month = inputDate.getMonth();
      const prevMonth = new Date(year, month - 1, 20);
      const nextMonth = new Date(year, month + 1, 10);
      startDate = formatDate(prevMonth);
      endDate   = formatDate(nextMonth);
    } else {
      throw new Error('Invalid mode. Supported modes are: day, week, month.');
    }

    return { startDate, endDate };
  }

  resetData(): void {
    this._localStorageService.removeLocalStorage('job_calendar_filter');
    this._localStorageService.removeLocalStorage('quick_filter_uid');
    this.selectedQuickFilter = 'ALL';
    this.calendarParams['filter.keyword'] = '';
    this.calendarSearchKeyword = '';
    this.calendarParams['filter.keyword'] = '';
    this.ngxTippyService.hide('tippycalendarSearch');
    this.filteredSubscription?.unsubscribe();
    this.filterSubscription?.unsubscribe();
    this.filterForm.reset(); // Reset the form
    this.filteredEmployeesArray = [];
    this.filteredJobCategoryArray = [];
    this.filteredTeamsArray = [];
    this.filteredStatusArray = [];
    this.selectedEmployeesItems = [];
    this.selectedJobCategoryItems = [];
    this.selectedStatusItems = [];
    this.selectedTeamsItems = [];
  }

  resetFilterForm(event?: Event): void {
    this.isAnyStatus = false;
    this.advancedFilterCount = 0;
    this.selectedQuickFilter = 'ALL';
    if (event) {
      event.stopPropagation(); // Stop the event from propagating to the parent elements
    }
    this.resetData();
    this.updateFiltersInPopup();
    const { startDate, endDate } = this.getStartAndEndDate(this.calendar.date);
    const filter = {
      'filter.job_category': '',
      'from_date': startDate,
      'to_date': endDate,
      'view': this.calendarMode.toUpperCase()
    };
    this.getJobsByFilter(filter);
    this.getAllEmployees();
    this.getAllTeams();
  }

  addNewJobCalendarFilter(): void {
    this.calendarFilterDrawerData.addNewFilter = true;
    this.calendarFilterDrawerData.openFilter = true;
    this.calendarFilterDrawerData.saveFilterByDefault = true;
    this.calendarFilterDrawerData.jobCalendarFilterValues = this.getJobCalendarFilterValues();
  }



  getJobCalendarFilterValues(): any {
    const jobCalendarFilterValues = this.defaultFilterOptions;
    return jobCalendarFilterValues.job;
  }

  manageQuickFilters(): void {
    const manageFilter: any = this._zuperDialogService.openCustom(ManageCalendarFilterComponent,
      {
        extraClass: 'manage-dispatch-filters-container',
      });
    manageFilter.afterClosed().subscribe((response: any) => {
      this.selectedQuickFilter = this.fallbackSelectedQuickFilter;
      if (response?.createNewFilter) {
        const jobCalendarFilterValues: any = {
          filterOptions: null,
          sortOptions: {
            grid: { ...this.sortOptions.grid }
          },
          filterUid: 'ALL'
        };
        this.calendarFilterDrawerData.jobCalendarFilterValues = jobCalendarFilterValues;
        this.calendarFilterDrawerData.addNewFilter = true;
        this.calendarFilterDrawerData.openFilter = true;
      }

      if (response?.isFilterUpdated) {
        if (response?.type !== 'close' && response?.type !== 'save') {
          this.selectedQuickFilter = 'ALL';
          this._localStorageService.removeLocalStorage('quick_filter_uid');
        } else {
          this._localStorageService.removeLocalStorage('job_calendar_filter');
        }
        this.getQuickFilters(false);
      }
    });
  }

  onQuickFilterChange(filterUid: any, skipComparison: boolean, init): any {
    this.advancedFilterCount = 0;
    this._localStorageService.removeLocalStorage('job_calendar_filter');
    this._localStorageService.setLocalStorage('quick_filter_uid', filterUid);
    this.advancedFilterCount = 0;
    this.filteredEmployeesArray = [];
    this.filteredJobCategoryArray = [];
    this.filteredTeamsArray = [];
    this.filteredStatusArray = [];
    this.filterForm.reset();
    if (filterUid === 'ADD') {
      this._analytics.trackEvent('web_calendar_quick_filter_add_filter_button_clicked');
      this.addNewJobCalendarFilter();
      return;
    }
    else if (filterUid === 'MANAGE') {
      this.manageQuickFilters();
      return;
    }
    this.calendarFilterDrawerData.openFilter = false;
    this.selectedQuickFilter = filterUid;
    this.fallbackSelectedQuickFilter = filterUid;
    //Save to local
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const filter = _.find(this.quickFilters, { 'filter_uid': filterUid });
    const quickFilterData = filter?.filter_options;
    if (quickFilterData) {
      this.calendarSearchKeyword = quickFilterData['filter.keyword'];
      const searchKeyword = this.calendarSearchKeyword?.trim();
      this.calendarParams['filter.keyword'] = searchKeyword;
    }
    const filterOptions = filter?.filter_options?.filterOptions
      ? filter?.filter_options?.filterOptions
      : filter?.filter_options;
    if (!filter) {
      filterUid = 'ALL';
      this.selectedQuickFilter = 'ALL';
      this._localStorageService.removeLocalStorage('quick_filter_uid');
      return this.resetFilterForm();
    } else {
      if (filterUid === 'ALL') {
        this.resetFilterForm();
        //  this.getAllJobs();
      }
    }

    // this.updateFilterValuesLocal(quickFilterData);
    this.calendarFilterDrawerData.jobCalendarFilterValues = quickFilterData;

    if (filterOptions) {
      this.filterSubscription?.unsubscribe();
      this.filterCount = quickFilterData.filterCount;
      // this.updateSelectedQuickFilterValue(filterUid, this.filterCount);
      // this.applyQuickFilter(filterOptions, sortOptions, skipComparison);
      const { startDate, endDate } = init ? this.getInitialStartAndEndDate() : this.getStartAndEndDate(this.calendar.date);
      filterOptions.from_date = startDate;
      filterOptions.to_date = endDate;
      this.assignFilteredData(filterOptions, true);
    }
  }

  updateSelectedQuickFilterValue(filterUid: any, filterCount?: any): void {
    const quickFilterOptions = this.getJobCalendarFilterValues();
    quickFilterOptions['filterUid'] = filterUid;
    quickFilterOptions['filterCount'] = filterCount || this.filterCount;
    // this.updateFilterValuesLocal(quickFilterOptions);
  }

  refreshFilterCount(): void {
    const filterCount = this._localStorageService.getLocalStorage('job_calendar_filter')?.job.filterCount || this.filterCount;
    this.filterCount = filterCount;
  }

  updateFilterValuesLocal(values: any): void {
    const dispatchBoardFilters = this._localStorageService.getLocalStorage('job_calendar_filter') || this.defaultFilterOptions;
    dispatchBoardFilters.job = values;
    this._localStorageService.setLocalStorage('job_calendar_filter', dispatchBoardFilters);
  }

  getQuickFilters(init: boolean, newFilterUid: any = this.selectedQuickFilter): void {
    const params = {
      'count': '50',
      'filter.module': 'JOB_CALENDAR',
      'page': '1'
    };
    this.quickFilterLoading = true;
    this._dataCollectorService.getData(this._dispatchBoardService.quickFilterUrl, params)
      .subscribe((response: any) => {
        this.quickFilters = response?.data;
        if (this.selectedQuickFilter) {
          this.onQuickFilterChange(this.selectedQuickFilter, true, init);
        } else {
          this.selectedQuickFilter = 'ALL';
          this.getFirstAllJobs();
        }
        this.quickFilterLoading = false;
      },
        (error: any) => {
          this.onQuickFilterChange('ALL', true, true);
          this.quickFilterLoading = false;
        });
  }

  setQuickFilterPreference(): void {
    //Quick filter preferences
    let dispatchBoardFilter = this._localStorageService.getLocalStorage('job_calendar_filter');
    if (!dispatchBoardFilter) {
      dispatchBoardFilter = this.defaultFilterOptions;
      this._localStorageService.setLocalStorage('job_calendar_filter', this.defaultFilterOptions);
      this.calendarFilterDrawerData.addNewFilter = true;
    }
    const quickFilterOptions = dispatchBoardFilter.job;
    this.selectedQuickFilter = quickFilterOptions?.filterUid || 'ALL';
  }

  getJobsByFilter(params): void {
    this.loaded = false;
    this.getEventCount(this.calendar.date, params);
    this.getNonJobEventData();
    if (this.metaData?.calendar?.display?.show_timeoff) {
      this.gettimeOffList(this.getFilterParams()['from_date'], this.getFilterParams()['to_date']);
    }
    this.filterSubscription = this._dataCollectorService.getData(this._dispatchBoardService.jobCalendarDataUrl, params).subscribe((res: any): void => {
      this.jobsArrBackup = res.data;
      if (this.calendarMode !== 'month') {
        this.jobsArr = this.events = this.splitJobs(res.data);
        this.calendar.eventStore.loadDataAsync(this.events);
      } else {
        res.data?.forEach((job, index) => {
          job.id = job.job_uid;
          if (job.scheduled_start_time && job.scheduled_end_time) {
            job.startDate = moment.tz(job.scheduled_start_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
            job.endDate = moment.tz(job.scheduled_end_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
          }
          job.eventColor = '#3c763d';
          job.eventType = 'JOB';
          if (job.current_job_status && job.current_job_status.status_type === 'CLOSED') {
            job.resizable = false;
            job.draggable = false;
          }
        });
        this.jobsArr = this.events = res.data;
      }
      this.events.push(...this.holidays);
      if (this.metaData?.calendar?.display?.show_timeoff) {
        this.events.push(...this.timeOffList);
      }
      this.events.push(...this.calendarNonJobEvents);
      this.updateCalendarStore();
      // this.events = this.jobsArr;
      this._dispatchBoardService.setCalendarRecords(this.jobsArr);
      this.loaded = true;
    });
  }

  getOriginalJobUid(jobUidWithDate: string): string {
    if(!jobUidWithDate){
      return null;
    }
    const generatedClassPrefix = '_generatedModelClass_';
    if (jobUidWithDate?.startsWith(generatedClassPrefix)) {
      return jobUidWithDate = jobUidWithDate?.substring(generatedClassPrefix.length);
    }
    const dateIndex = jobUidWithDate?.lastIndexOf('-');
    const formatIndex = jobUidWithDate?.lastIndexOf('_');

    if (dateIndex !== -1 && formatIndex !== -1 && formatIndex > dateIndex) {
      // If date exists and is in the expected format, remove it
      const originalJobUid = jobUidWithDate?.substring(0, dateIndex);
      return originalJobUid;
    } else {
      // If date doesn't exist or is not in the expected format, return the original job_uid
      return jobUidWithDate;
    }
  }

  getFirstFilterParams(): any {
    const jobCalendarFilter = this._localStorageService.getLocalStorage('job_calendar_filter');
    if (jobCalendarFilter) {
      // eslint-disable-next-line max-len
      this.calendarSearchKeyword = jobCalendarFilter ? jobCalendarFilter['filter.keyword'] : '';
      const searchKeyword = this.calendarSearchKeyword?.trim();
      this.calendarParams['filter.keyword'] = searchKeyword;
      // eslint-disable-next-line max-len
      this.selectedJobCategoryItems = jobCalendarFilter ? jobCalendarFilter['filter.job_category'] ? jobCalendarFilter['filter.job_category']?.split(',').map(id => id.trim()) : [] : [];
      this.filteredJobCategoryArray = this.jobsCategory.filter(obj => this.selectedJobCategoryItems?.includes(obj.category_uid));
      this.filterForm.get('jobCategory').setValue(this.selectedJobCategoryItems);
      const selectedCategories: any[] = this.filterForm.get('jobCategory')?.value ?? [];
      this.jobsStatuses = selectedCategories.length > 0 ? this.getSelectedCategoriesStatus(selectedCategories) : [];
      this.selectedStatusItems = jobCalendarFilter ? jobCalendarFilter['filter.job_status'] ? jobCalendarFilter['filter.job_status']?.split(',').map(id => id.trim()) : [] : [];
      this.filteredStatusArray = this.jobsStatuses?.filter(obj => this.selectedStatusItems?.includes(obj.status_uid));
      this.filterForm.get('jobStatus').setValue(this.selectedStatusItems);
      if (this.selectedJobCategoryItems.length > 0 && this.jobsStatuses.length !== 0 && (this.jobsStatuses.length === this.filteredStatusArray.length)) {
        this.isAnyStatus = true;
      } else {
        this.isAnyStatus = false;
      }
      // eslint-disable-next-line max-len
      this.selectedTeamsItems = jobCalendarFilter ? jobCalendarFilter['filter.assigned_to_team'] ? jobCalendarFilter['filter.assigned_to_team']?.split(',').map(id => id.trim()) : [] : [];
      this.filteredTeamsArray = this.teamOptions.filter(obj => this.selectedTeamsItems?.includes(obj.team_uid));
      this.filteredTeamsArray = this.filteredTeamsArray.filter((value, index, self) =>
        self.findIndex(v => v.team_uid === value.team_uid) === index);
      this.filterForm.get('teams').setValue(this.filteredTeamsArray);
      // eslint-disable-next-line max-len
      this.selectedEmployeesItems = jobCalendarFilter ? jobCalendarFilter['filter.assigned_to'] ? jobCalendarFilter['filter.assigned_to']?.split(',').map(id => id.trim()) : [] : [];
      this.filteredEmployeesArray = this.employeeOptions.filter(obj => this.selectedEmployeesItems?.includes(obj.user_uid));
      this.filteredEmployeesArray = this.filteredEmployeesArray.filter((value, index, self) =>
        self.findIndex(v => v.user_uid === value.user_uid) === index);
      this.filterForm.get('employees').setValue(this.filteredEmployeesArray);
      const { startDate, endDate } = this.getInitialStartAndEndDate();
      jobCalendarFilter['filter.job_category'] = this.selectedJobCategoryItems ? this.selectedJobCategoryItems.join(',') : '';
      jobCalendarFilter['filter.assigned_to_team'] = this.selectedTeamsItems ? this.selectedTeamsItems.join(',') : '';
      jobCalendarFilter['filter.assigned_to'] = this.selectedEmployeesItems ? this.selectedEmployeesItems.join(',') : '';
      jobCalendarFilter['filter.job_status'] = this.selectedStatusItems ? this.selectedStatusItems.join(',') : '';
      jobCalendarFilter['from_date'] = startDate;
      jobCalendarFilter['to_date'] = endDate;
      jobCalendarFilter['view'] = this.calendarMode.toUpperCase();
      return jobCalendarFilter;
    } else {
      const { startDate, endDate } = this.getInitialStartAndEndDate();
      return {
        'filter.job_category': this.selectedJobCategoryItems ? this.selectedJobCategoryItems.join(',') : '',
        'filter.assigned_to_team': this.selectedTeamsItems ? this.selectedTeamsItems.join(',') : '',
        'filter.assigned_to': this.selectedEmployeesItems ? this.selectedEmployeesItems.join(',') : '',
        'filter.job_status': this.selectedStatusItems ? this.selectedStatusItems.join(',') : '',
        'from_date': startDate,
        'to_date': endDate,
        'view': this.calendarMode.toUpperCase(),
        'filter.keyword': this.calendarParams['filter.keyword'] || ''
      };
    }

  }

  getInitialStartAndEndDate(): any {
    const inputDate = this.selectedRedirectedDate;
    let startDate, endDate;

    const formatDate = (d: Date): string => {
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    if (this.calendarMode === 'day') {
      startDate = formatDate(inputDate);
      endDate = startDate;
    } else if (this.calendarMode === 'week') {
      const startDateObject = new Date(inputDate);
      startDateObject.setDate(startDateObject.getDate() - 7);

      const endDateObject = new Date(inputDate);
      endDateObject.setDate(endDateObject.getDate() + 7);

      const formatWeekDate = (d) => {
        const year = d.getFullYear();
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      startDate = formatWeekDate(startDateObject);
      endDate = formatWeekDate(endDateObject);

    } else if (this.calendarMode === 'month') {
      const year = inputDate.getFullYear();
      const month = inputDate.getMonth();
      const prevMonth = new Date(year, month - 1, 20);
      const nextMonth = new Date(year, month + 1, 10);
      startDate = formatDate(prevMonth);
      endDate   = formatDate(nextMonth);
    } else {
      const year = inputDate.getFullYear();
      const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
      startDate = `${year}-${month}-01`;

      const nextMonth = new Date(year, inputDate.getMonth() + 1, 1);
      nextMonth.setDate(nextMonth.getDate() - 1);
      const endYear = nextMonth.getFullYear();
      const endMonth = (nextMonth.getMonth() + 1).toString().padStart(2, '0');
      endDate = `${endYear}-${endMonth}-${nextMonth.getDate()}`;
    }

    return { startDate, endDate };
  }

  getFilterParams(date?: any): any {
    const jobCalendarFilter = this._localStorageService.getLocalStorage('job_calendar_filter');
    if (jobCalendarFilter) {
      const { startDate, endDate } = this.getStartAndEndDate(date || this.calendar.date);
      jobCalendarFilter['filter.job_category'] = this.selectedJobCategoryItems ? this.selectedJobCategoryItems.join(',') : '';
      jobCalendarFilter['filter.assigned_to_team'] = this.selectedTeamsItems ? this.selectedTeamsItems.join(',') : '';
      jobCalendarFilter['filter.assigned_to'] = this.selectedEmployeesItems ? this.selectedEmployeesItems.join(',') : '';
      jobCalendarFilter['filter.job_status'] = this.selectedStatusItems ? this.selectedStatusItems.join(',') : '';
      jobCalendarFilter['from_date'] = startDate;
      jobCalendarFilter['to_date'] = endDate;
      jobCalendarFilter['view'] = this.calendarMode.toUpperCase();
      return jobCalendarFilter;
    } else {
      const { startDate, endDate } = this.getStartAndEndDate(date || this.calendar.date);
      return {
        'filter.job_category': this.selectedJobCategoryItems ? this.selectedJobCategoryItems.join(',') : '',
        'filter.assigned_to_team': this.selectedTeamsItems ? this.selectedTeamsItems.join(',') : '',
        'filter.assigned_to': this.selectedEmployeesItems ? this.selectedEmployeesItems.join(',') : '',
        'filter.job_status': this.selectedStatusItems ? this.selectedStatusItems.join(',') : '',
        'from_date': startDate,
        'to_date': endDate,
        'view': this.calendarMode.toUpperCase(),
        'filter.keyword': this.calendarParams['filter.keyword'] || ''
      };
    }

  }

  changeJobCategory(items: any): void {
    if (items.length === 1 && items[0]?.selectedAllCategories && !items[0]?.category_uid) {
      this.filterForm.get('jobCategory').setValue(this.jobsCategory.map((category: any) => category.category_uid));
    }
    this.selectedQuickFilter = 'ALL';
    this.filterSubscription?.unsubscribe();
    this.selectedJobCategoryItems = this.filterForm.get('jobCategory').value;
    this.filteredJobCategoryArray = this.jobsCategory.filter(obj => this.selectedJobCategoryItems.includes(obj.category_uid));
    this.getJobsByFilter(this.getFilterParams());
    const selectedCategories: any[] = this.filterForm.get('jobCategory')?.value ?? [];
    this.jobsStatuses = selectedCategories.length > 0 ? this.getSelectedCategoriesStatus(selectedCategories) : [];
    this.filteredStatusArray = this.jobsStatuses.filter(obj => this.selectedStatusItems.includes(obj.status_uid));
    this.selectedStatusItems = this.filteredStatusArray.map((status: any) => status.status_uid);
    if (this.selectedJobCategoryItems.length > 0 && this.jobsStatuses.length !== 0 && (this.jobsStatuses.length === this.filteredStatusArray.length)) {
      this.isAnyStatus = true;
    } else {
      this.isAnyStatus = false;
    }
    this.filterForm.get('jobStatus').setValue(this.selectedStatusItems);
    this.storeFilterData();
    this.updateFiltersInPopup();
  }

  getSelectedCategoriesStatus(selectedCategories: any[]): any[] {
    let status: any[] = [];
    selectedCategories.forEach((sCategory: any) => {
      const category: any = this.jobsCategory.find((jCategory: any) => jCategory.category_uid === sCategory);
      if (category?.job_statuses?.length) {
        category?.job_statuses.forEach((cStatus: any) => {
          cStatus['category_name'] = category.category_name;
          cStatus['category_uid'] = category.category_uid;
        });
        status = status.concat(category?.job_statuses);
      }
    });
    return status;
  }

  setAnyJobStatus(event: any): void {
    event.stopPropagation();
    if (event?.target?.checked) {
      this.isAnyStatus = true;
      // this.selectedStatusItems = filter ? filter['filter.status'] ? filter['filter.status']?.split(',').map(id => id.trim()) : '' : [];
      this.selectedStatusItems = this.jobsStatuses.map((status: any) => status.status_uid);
      this.filteredStatusArray = this.jobsStatuses.filter(obj => this.selectedStatusItems.includes(obj.status_uid));
      this.filterForm.get('jobStatus').setValue(this.selectedStatusItems);
    } else {
      this.filterForm.get('jobStatus').setValue([]);
      this.isAnyStatus = false;
      this.selectedStatusItems = [];
      this.filteredStatusArray = [];
    }
    this.filterSubscription?.unsubscribe();
    this.getJobsByFilter(this.getFilterParams());
    this.storeFilterData();
    this.updateFiltersInPopup();
  }

  changeTeams(items: any): void {
    this.selectedQuickFilter = 'ALL';
    this.filteredTeamsArray = items;
    this.selectedTeamsItems = [];
    this.filteredTeamsArray?.forEach((team: any) => {
      this.selectedTeamsItems.push(team.team_uid);
    });
    this.filterSubscription?.unsubscribe();
    this.getJobsByFilter(this.getFilterParams());
    // if(this.filteredTeamsArray.length === 0){
    //   this.getAllTeams();
    // }
    this.storeFilterData();
    this.updateFiltersInPopup();
  }

  changeUsers(items: any): void {
    this.selectedQuickFilter = 'ALL';
    this.filteredEmployeesArray = items;
    this.selectedEmployeesItems = [];
    this.filteredEmployeesArray?.forEach((user: any) => {
      this.selectedEmployeesItems.push(user.user_uid);
    });
    this.filterSubscription?.unsubscribe();
    this.getJobsByFilter(this.getFilterParams());
    // if(this.filteredEmployeesArray.length === 0){
    //   this.getAllEmployees();
    // }
    this.storeFilterData();
    this.updateFiltersInPopup();
  }


  changeJobStatus(items: any): void {
    this.selectedQuickFilter = 'ALL';
    this.filterSubscription?.unsubscribe();
    this.selectedStatusItems = this.filterForm.get('jobStatus').value;
    this.filteredStatusArray = this.jobsStatuses.filter(obj => this.selectedStatusItems.includes(obj.status_uid));
    if (this.selectedJobCategoryItems.length > 0 && this.jobsStatuses.length !== 0 && (this.jobsStatuses.length === this.filteredStatusArray.length)) {
      this.isAnyStatus = true;
    } else {
      this.isAnyStatus = false;
    }
    this.getJobsByFilter(this.getFilterParams());
    this.storeFilterData();
    this.updateFiltersInPopup();
  }

  removeJobCategoryItem(item: any): any {
    this.filterSubscription?.unsubscribe();
    // Remove the selected item from the list
    const index = this.selectedJobCategoryItems.findIndex((itm: any) => itm === item.category_uid);
    if (index > -1) {
      this.selectedJobCategoryItems.splice(index, 1);
      this.filteredJobCategoryArray.splice(index, 1);
      this.filterForm.get('jobCategory').setValue(this.selectedJobCategoryItems);
      this.getJobsByFilter(this.getFilterParams());
      this.storeFilterData();
      const selectedCategories: any[] = this.filterForm.get('jobCategory')?.value ?? [];
      this.jobsStatuses = selectedCategories.length > 0 ? this.getSelectedCategoriesStatus(selectedCategories) : [];
    }
    this.selectedQuickFilter = 'ALL';
    this.updateFiltersInPopup();
  }
  removeTeamItem(item: any): any {
    this.filterSubscription?.unsubscribe();
    // Remove the selected item from the ?
    const index = this.selectedTeamsItems.findIndex((itm: any) => itm === item.team_uid);
    if (index > -1) {
      this.selectedTeamsItems.splice(index, 1);
      this.filteredTeamsArray.splice(index, 1);
      this.filterForm.get('teams').setValue(this.filteredTeamsArray);
      this.getJobsByFilter(this.getFilterParams());
      this.storeFilterData();
    }
    this.selectedQuickFilter = 'ALL';
    this.updateFiltersInPopup();
  }
  removeStatusItem(item: any): any {
    this.filterSubscription?.unsubscribe();
    // Remove the selected item from the ?
    const index = this.selectedStatusItems.findIndex((itm: any) => itm === item.status_uid);
    if (index > -1) {
      this.selectedStatusItems.splice(index, 1);
      this.filteredStatusArray.splice(index, 1);
      this.filterForm.get('jobStatus').setValue(this.selectedStatusItems);
      this.getJobsByFilter(this.getFilterParams());
      this.storeFilterData();
    }
    this.selectedQuickFilter = 'ALL';
    this.updateFiltersInPopup();
  }

  removeEmployeeItem(item: any): any {
    this.filterSubscription?.unsubscribe();
    // Remove the selected item from the list
    const index = this.selectedEmployeesItems.findIndex((itm: any) => itm === item.user_uid);
    if (index > -1) {
      this.selectedEmployeesItems.splice(index, 1);
      this.filteredEmployeesArray.splice(index, 1);
      this.filterForm.get('employees').setValue(this.filteredEmployeesArray);
      this.getJobsByFilter(this.getFilterParams());
      this.storeFilterData();
    }
    this.selectedQuickFilter = 'ALL';
    this.updateFiltersInPopup();
  }

  storeFilterData(): void {
    this._localStorageService.setLocalStorage('job_calendar_filter', this.getFilterValues());
    this._localStorageService.removeLocalStorage('quick_filter_uid');
    const jobCalendarFilter = this._localStorageService.getLocalStorage('job_calendar_filter');
    if (jobCalendarFilter) {
      this.advancedFilterCount = Object.keys(jobCalendarFilter)
        .filter(key => jobCalendarFilter[key] && jobCalendarFilter[key] !== 'ANY' && key !== 'filter.job_category' && key !== 'filter.job_status' && key !== 'filter.assigned_to_team' && key !== 'filter.assigned_to' && key !== 'from_date' && key !== 'to_date')
        .length;

    }
  }

  getFilterCountOptions(): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: 'HIGH',
      displayKey: this.advancedFilterCount?.toString(),
      displayName: this.advancedFilterCount?.toString(),
      displayType: 'listingCount',
      color: '#FFF',
      backgroundColor: '#E44A19',
      extraClass: 'filterCountNumber',
    };
    return badgeOption;
  }

  openGridDrawer(): void {
    this.gridDrawerOptions.show = !this.gridDrawerOptions.show;
    if (this.gridDrawerOptions.show) {
      this._analytics.trackEvent('web_calendar_unscheduled_jobs_button_clicked');
      this.getGridData();
      this.gridDrawerOptions.show = true;
      if (!this.gridInstance) {
        this.gridInstance = this.gridViewInstance?.instance;
      }
      if (this.gridInstance) {
        this.gridInstance.data = this.grid.unscheduledJobs;
      }
    }
  }

  //Grid
  setGridCardConfig(): void {
    this.gridCardConfig = {
      hideHeaders: true,
      fullRowRefresh: true,
      columns: [{
        type: 'template',
        readOnly: true,
        autoHeight: true,
        template: (record: any): string => {
          const jobDetails = record.record?.data;
          return this._calendarService.getGridCardRenderer(jobDetails);
        }
      }],
      onCellClick: (record: any): void => {
        const jobDetails = record.record?.data;
        const jobUid = jobDetails?.job_uid;
        if (jobUid) {
          this.calendarFilterDrawerData.openFilter = false;
          this._dispatchBoardService.jobPreview.next(this.getOriginalJobUid(jobUid));
        }
      },
      features: {
        cellMenu: false,
        headerMenu: false
      }
    };
  }

  gridDrawerEvent(event: any): void {
  }

  closeGridDrawer(): void {
    this.gridDrawerOptions.show = false;
  }

  gridPageIncrement(type: 'next' | 'prev'): void {
    const updatedPageNumber = type === 'next' ? Number(this.gridPageNumber) + 1 : Number(this.gridPageNumber) - 1;
    if (updatedPageNumber > 0 && updatedPageNumber <= this.totalGridPage) {
      this.gridParam['page'] = updatedPageNumber;
      this.gridPageNumber = updatedPageNumber.toString();
      this.getGridData();
    }
  }

  getGridData(): any {
    const param = _.cloneDeep(this.gridParam);
    const jobsUrl = `${this._dataCollectorService.baseurl()}/jobs/filter`;
    this._dataCollectorService.postData(jobsUrl, param)
      .subscribe((response: any) => {
        this.grid.unscheduledJobs = [];
        this.grid.allJobs = response?.data || [];
        if (this.grid.allJobs) {
          this.grid.allJobs.forEach((job: any) => {
            job['name'] = job.job_title;
            job['duration'] = ((job.job_category?.estimated_duration?.days * 24) + job.job_category?.estimated_duration?.hours + (job.job_category?.estimated_duration?.minutes / 60)) || 1;
            job['durationUnit'] = 'h';
            job['id'] = job?.job_uid;
            this.grid.unscheduledJobs.push(job);
          });
          this.grid.unscheduledJobcount = this.totalGridRecords = response.total_records;
          this.totalGridPage = response.total_pages;
          this.gridData = this.grid.unscheduledJobs;
          this.currentPageNumber = response.current_page;
        }
      });
  }

  updateGridPageNumber(event: any): void {
    if (+this.gridPageNumber) {
      this.gridParam['page'] = +this.gridPageNumber;
      this.getGridData();
    }
  }

  calendarActions(menu): any{
    switch (menu.dataKey) {
      case 'ADD_TIMEOFF':
        this.addTimeOff();
        break;
      case 'NEW_NON_JOB_EVENT':
        this.addNewNonJobEvent(null);
      break;
      case 'CREATE_JOB':
        this.createNewJob(null);
      break;
    }
  }

  addTimeOff(): void {
    this._analytics.trackEvent('web_calendar_add_timeoff_button_clicked');
    const newTimeoffDialogInstance = this._zuperDialogService.openCustom(NewTimeOffComponent,
      { disableClose: true, extraClass: 'new-timeoff', action: 'create' }
    );
    newTimeoffDialogInstance.afterClosed()
      .subscribe((result) => {
        if (result.status) {
          this._analytics.trackEvent('web_calendar_add_timeoff_submit_button_clicked');
          this.getAllJobs(this.calendar.date);
        } else {
          this._analytics.trackEvent('web_calendar_add_timeoff_cancel_button_clicked');
        }
      });
  }

  gettimeOffList(startDate, endDate): void {
    const param = {
      'filter.from_date': moment(startDate).format('YYYY-MM-DD'),
      'filter.to_date': moment(endDate).format('YYYY-MM-DD')
    };
    this._dataCollectorService.getData(this._calendarService.timeofflist, param).subscribe((response: any) => {
      this.timeOffList = response.data;
      this.timeOffList.forEach((timeOff) => {
        timeOff.startDate = moment(timeOff.request_from).format('YYYY-MM-DD HH:mm');
        timeOff.endDate = moment(timeOff.request_to).format('YYYY-MM-DD HH:mm');
        timeOff.allDay = true;
        timeOff.id = timeOff.request_uid;
        timeOff.allDayEventType = 'timeoff';
        timeOff.resizable = false;
        timeOff.draggable = false;
      });
    }, (_error: any) => {
    });
  }

  gettimeOffListObservable(startDate, endDate): any {
    const param = {
      'filter.from_date': moment(startDate).format('YYYY-MM-DD'),
      'filter.to_date': moment(endDate).format('YYYY-MM-DD')
    };
   return this._dataCollectorService.getData(this._calendarService.timeofflist, param).pipe(
      tap((response: any) => {
        this.timeOffList = response.data;
        this.timeOffList.forEach((timeOff) => {
          timeOff.startDate = moment(timeOff.request_from).format('YYYY-MM-DD HH:mm');
          timeOff.endDate = moment(timeOff.request_to).format('YYYY-MM-DD HH:mm');
          timeOff.allDay = true;
          timeOff.id = timeOff.request_uid;
          timeOff.allDayEventType = 'timeoff';
          timeOff.resizable = false;
          timeOff.draggable = false;
        });
      })
    );
  }
  

  editTimeOff(timeoffDetails: any): void {
    this._calendarService.editTimeOffEvent(timeoffDetails, [timeoffDetails?.requested_by], [timeoffDetails?.requested_by_team], this.selectedTimeZone, (status: boolean, userUid: string, timeoff: any) => {
      if (status) {
        this.getAllJobs(this.calendar.date);
      }
    });
  }

  viewTimeoffDetails(recordData): void {
    const timeoffDetails = this.zuperDialogService.openCustom(TimeoffDetailsComponent, { disableClose: true, extraClass: 'add-time-off-dialog', data: recordData });
    timeoffDetails.afterClosed().subscribe((result: any) => {
      if (result === 'success') {
        this.getAllJobs(this.calendar.date);
      } else if (result === 'openDetails') {
        this.viewTimeoffDetails(recordData);
      }
    });
  }

  addNewNonJobEvent(dragData): any{
    // this.schedulerNewEventDialogInstance?.close();
    if (this._utilityService.isEmptyOrUndefined(dragData)) {
      this.nonJobEventCreateDrawerData.eventData = null;
    }
    else {
      const eventStartDateTime: string = moment.tz(moment(dragData?.startDate?.clone().format('YYYY-MM-DD') + ' ' + dragData?.startTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'), this.selectedTimeZone).tz('UTC').toISOString();
      const eventEndDateTime: string = moment.tz(moment(dragData?.startDate?.clone().format('YYYY-MM-DD') + ' ' + dragData?.endTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'), this.selectedTimeZone).tz('UTC').toISOString();
      const assignedTo: any[] = [{user: dragData?.user, team: dragData?.team}];
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const eventData: any = { assigned_to: assignedTo, start_time: eventStartDateTime, end_time: eventEndDateTime };
      this.nonJobEventCreateDrawerData.eventData = eventData;
    }
    this.nonJobEventCreateDrawerData.source = null;
    this.nonJobEventCreateDrawerData.options = { header: 'non_job_event.create.title', state: 'new' };
    this.nonJobEventCreateDrawerData.openDrawer = true;
  }

  nonJobEventEmitHandler(event: any): void {
    if (event?.isClosed) {
      this.nonJobEventCreateDrawerData.openDrawer = false;
      if (event?.action === 'create' && event?.isCompleted) {
        this.getNonJobEventData(true);
      }
      else if (event?.action === 'edit' && event?.isCompleted) {
        if (event?.isRecurrence) {
          this.closeNonJobEventPreview();
          this.getNonJobEventData(true);
        }
        else if (event?.data?.event_uid) {
          this.getNonJobEventData(true);
          if (this.nonJobEventCreateDrawerData.source === 'detailsPage') {
            this.openNonJobEventPreview(event?.data?.event_uid);
            this.nonJobEventCreateDrawerData.source = null;
          }
        }
      }
    }
  }

  closeNonJobEventPreview(): void {
    this.nonJobEventDetailsDrawerData.nonJobEventUid = null;
    this.nonJobEventDetailsDrawerData.openDrawer = false;
    this.nonJobEventDetailsDrawerData.options = null;
  }

  getNonJobEventData(update?: boolean): void {
    const { startDate, endDate } = this.getStartAndEndDate(this.calendar.date);
    this.nonJobEventParams['filter.from_date'] = startDate;
    this.nonJobEventParams['filter.to_date'] = endDate;
    this.nonJobEventParams['filter.assigned_to_team'] = this.selectedTeamsItems ? this.selectedTeamsItems.join(',') : '';
    this.nonJobEventParams['filter.assigned_to'] = this.selectedEmployeesItems ? this.selectedEmployeesItems.join(',') : '';
    // this.nonJobEventParams['filter.assigned_to_team'] = this.selectedTeam;
    const params: any = _.cloneDeep(this.nonJobEventParams);
    this._dataCollectorService.getData(this._dispatchBoardService.nonJobEventDataUrl, params)
      .pipe(takeUntil(this.cancelNonJobEventRequest))
      .subscribe((response: any) => {
        const nonJobEvents: any[] = response?.data || [];
        this.calendarNonJobEvents = [];
        if (this.calendarMode !== 'month') {
          this.calendarNonJobEvents = this.splitNonJobEvents(nonJobEvents);
        } else {
          nonJobEvents.forEach((nonJobEvent: any) => {
            nonJobEvent.id = nonJobEvent?.event_uid;
            nonJobEvent.eventType = 'non_job_event';
            if (nonJobEvent?.start_time && nonJobEvent?.end_time) {
              nonJobEvent.startDate = moment.tz(nonJobEvent.start_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
              nonJobEvent.endDate = moment.tz(nonJobEvent.end_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
            }
            nonJobEvent.resizable = false;
            nonJobEvent.draggable = false;
            this.calendarNonJobEvents.push(nonJobEvent);
          });
        }
        if(update){
          this.updateCalendarData();
        }
      }, (error: any) => {
      });

  }

  getNonJobEventDataObservable(): Observable<any> {
    const { startDate, endDate } = this.getStartAndEndDate(this.calendar.date);
    this.nonJobEventParams['filter.from_date'] = startDate;
    this.nonJobEventParams['filter.to_date'] = endDate;
    this.nonJobEventParams['filter.assigned_to_team'] = this.selectedTeamsItems ? this.selectedTeamsItems.join(',') : '';
    this.nonJobEventParams['filter.assigned_to'] = this.selectedEmployeesItems ? this.selectedEmployeesItems.join(',') : '';
    const params: any = _.cloneDeep(this.nonJobEventParams);
  
    return this._dataCollectorService.getData(this._dispatchBoardService.nonJobEventDataUrl, params).pipe(
      tap((response: any) => {
        const nonJobEvents: any[] = response?.data || [];
        this.calendarNonJobEvents = [];
  
        if (this.calendarMode !== 'month') {
          this.calendarNonJobEvents = this.splitNonJobEvents(nonJobEvents);
        } else {
          nonJobEvents.forEach((nonJobEvent: any) => {
            nonJobEvent.id = nonJobEvent?.event_uid;
            nonJobEvent.eventType = 'non_job_event';
            if (nonJobEvent?.start_time && nonJobEvent?.end_time) {
              nonJobEvent.startDate = moment.tz(nonJobEvent.start_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
              nonJobEvent.endDate = moment.tz(nonJobEvent.end_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
            }
            nonJobEvent.resizable = false;
            nonJobEvent.draggable = false;
            this.calendarNonJobEvents.push(nonJobEvent);
          });
        }
      })
    );
  }

  splitNonJobEvents(nonJobEvents): any {
    const modifiedNonJobs = [];
    for (const nonJob of nonJobEvents) {
      nonJob.id = nonJob?.event_uid;
      nonJob.eventType = 'non_job_event';
      if (nonJob?.start_time && nonJob?.end_time) {
        nonJob.startDate = moment.tz(nonJob.start_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
        nonJob.endDate = moment.tz(nonJob.end_time, this._utilityService.preferredTimeZone).format('YYYY-MM-DD HH:mm');
      }
      nonJob.resizable = false;
      nonJob.draggable = false;
      const startDate = new Date(nonJob.startDate);
      const endDate = new Date(nonJob.endDate);
      if (startDate.toDateString() === endDate.toDateString()) {
        modifiedNonJobs.push(nonJob);
      } else {
        const splitNonJobs = this.splitMultiDayNonJob(nonJob, startDate, endDate);
        modifiedNonJobs.push(...splitNonJobs);
      }
    }

    return modifiedNonJobs;
  }

  splitMultiDayNonJob(nonJob, startDate, endDate): any {
    const splitNonJobs = [];
    const formatDateTime = (date) => {
      date = new Date(date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    };
  
    // Process the first day
    const firstDayEndTime = this.getMultiEndTime(startDate);
    const firstDayJob = { ...nonJob };
    firstDayJob.startDate = formatDateTime(nonJob.startDate);
    firstDayJob.endDate = formatDateTime(firstDayEndTime);
    firstDayJob.id = `${nonJob.id}-${this.formatSplitJobDate(startDate)}`;
    firstDayJob.resizable = false;
    firstDayJob.draggable = false;
    splitNonJobs.push(firstDayJob);
  
    // Move currentDay to the next day after the first day
    let currentDay = new Date(startDate);
    currentDay.setDate(currentDay.getDate() + 1);
  
    // Process the middle days only if the job spans more than two days
    while (currentDay < endDate && this.isMiddleDay(currentDay, endDate)) {
      const middleDayJob = { ...nonJob };
      middleDayJob.startDate = formatDateTime(this.getMultiStartTime(currentDay));
      middleDayJob.endDate = formatDateTime(this.getMultiEndTime(currentDay));
      middleDayJob.id = `${nonJob.id}-${this.formatSplitJobDate(currentDay)}`;
      middleDayJob.resizable = false;
      middleDayJob.draggable = false;
      splitNonJobs.push(middleDayJob);
      currentDay.setDate(currentDay.getDate() + 1);
    }
  
    // Process the last day
    const lastDayJob = { ...nonJob };
    lastDayJob.startDate = formatDateTime(this.getMultiStartTime(endDate));
    lastDayJob.endDate = formatDateTime(nonJob.endDate);
    lastDayJob.id = `${nonJob.id}-${this.formatSplitJobDate(endDate)}`;
    lastDayJob.resizable = false;
    lastDayJob.draggable = false;
    splitNonJobs.push(lastDayJob);
  
    return splitNonJobs;
  }

  async nonJobEventPreview(action_uid: string): Promise<void> {
    try {
      const response = await this.getNonJobEventDetails(action_uid);

      if (response) {
        this.calendarConfig.date = this.selectedRedirectedDate = new Date(response?.data?.start_time);
        this.calendar.mode = this.calendarMode = 'day';
        this.updateDateDesc();
        this.getQuickFilters(true, this.selectedQuickFilter);
        this.getEventCount(this.selectedRedirectedDate);
        this.openNonJobEventPreview(action_uid);
      } 
    } catch (error) {
    }
  }

  async getNonJobEventDetails(nonJobEventUid: string): Promise<any> {
    if (nonJobEventUid) {
        try {
            const nonJobEventUrl: string = `${this._dispatchBoardService.nonJobEventDataUrl}/${nonJobEventUid}`;
            const response = await this._dataCollectorService.getData(nonJobEventUrl).toPromise();
            return response;

        } catch (error) {
          this.getQuickFilters(true, this.selectedQuickFilter);
        }
    }
}

  openNonJobEventPreview(nonJobEventUid: string): void {
    if (nonJobEventUid) {
      this.nonJobEventDetailsDrawerData.nonJobEventUid = nonJobEventUid;
      this.nonJobEventDetailsDrawerData.openDrawer = true;
      this.nonJobEventDetailsDrawerData.options = { actions: { delete: true, edit: true } };
    }
  }

  nonJobEventDetailsDrawerEmitter(event: any): void {
    if (event?.isClosed) {
      this.closeNonJobEventPreview();
    }
    if (event?.action === 'edit') {
      if (event?.eventDetails) {
        this.nonJobEventCreateDrawerData.source = 'detailsPage';
        this.editNonJobEvent(event?.eventDetails);
      }
    }
    else if (event?.action === 'delete') {
      if (event?.isRecurrence) {
        this.getNonJobEventData(true);
      }
      else {
        const eventUid: string = event?.eventUid;
        this.getNonJobEventData(true);
      }
    }
  }

  editNonJobEvent(nonJobEventData: any): void {
    if (nonJobEventData?.is_recurrence) {
      const startDateTime = moment(nonJobEventData?.start_time).tz(this.selectedTimeZone).format('YYYY-MM-DD HH:mm');
      const actionSelectorOption: ActionSelectorOption = {
        title: `${this._utilityService.getLocaleValue('non_job_event.recurrence.edit.title', 'Edit Recurring Non Job Event')}`,
        options: [
          {
            key: 'SINGLE_EVENT',
            optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.edit.event_only_title', 'Update this event only'),
            optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.event_only_message', 'Applies to this event only')} (${startDateTime})`
          },
          {
            key: 'ALL_FUTURE_EVENTS',
            optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.edit.upcoming_event_title', 'Update this and upcoming events'),
            optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.upcoming_event_message', 'Applies to this and upcoming events in the series.')}`
          }
        ],
        primaryActionButtonText: this._utilityService.getLocaleValue('proceed', 'proceed'),
        primaryActionButtonType: 'primary'
      };
      const actionSelectorDialogRef = this._zuperDialogService.openCustom(ActionSelectorComponent, { data: actionSelectorOption, extraClass: 'non-job-delete-recurrence-dialog' });
      actionSelectorDialogRef.afterClosed().subscribe((response: any) => {
        if (response?.isSelected) {
          if (response?.selectedType && ['SINGLE_EVENT', 'ALL_FUTURE_EVENTS'].includes(response?.selectedType)) {
            this.closeNonJobEventPreview();
            this.nonJobEventCreateDrawerData.options = { header: 'non_job_event.edit.title', state: 'edit', editType: response?.selectedType };
            this.nonJobEventCreateDrawerData.openDrawer = true;
            this.nonJobEventCreateDrawerData.eventData = nonJobEventData;
          }
        }
      });
    }
    else {
      this.closeNonJobEventPreview();
      this.nonJobEventCreateDrawerData.options = { header: 'non_job_event.edit.title', state: 'edit', editType: 'SINGLE_EVENT' };
      this.nonJobEventCreateDrawerData.openDrawer = true;
      this.nonJobEventCreateDrawerData.eventData = nonJobEventData;
    }
  }

  getUserTeamId(userUid: any): string {
    let teamId = '';
    const calendarJobs = this.calendarConfig.events;
    calendarJobs.forEach((job: any) => {
      const assignedTo = job?.assigned_to?.filter((assignee: any) => assignee?.user.user_uid === userUid);
      if (assignedTo.length) {
        const teamUid = assignedTo[0]?.team.team_uid;
        if (!this._utilityService.isEmptyOrUndefined(teamUid)) {
          teamId = teamUid;
          return false;
        }
      }
    });
    return teamId;
  }

  ngOnDestroy(): void {
    this.rescheduleSubscription?.unsubscribe();
    this.newTimeoffSubscription?.unsubscribe();
    if (this.filteredSubscription) {
      this.filteredSubscription.unsubscribe();
    }
  }
}
